import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import {
    List,
    Datagrid,
    TextField as TextFieldRa,
    RichTextField,
    useShowController,
    TextInput,
    ShowButton,
    TopToolbar,
    Filter,
    useCheckAuth,
    useNotify,
    useRefresh,
    DatagridBody,
    SelectInput,
    DateInput,
    Edit,
    SimpleForm,
    ChipField,
    ArrayField,
    SingleFieldList,
    useRecordContext,
    FunctionField,
} from 'react-admin'
import {
    Button,
    Grid,
    TextField,
    Box,
    Paper,
    Tabs,
    Tab,
    Typography,
    AppBar,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    Tooltip,
    TableCell,
    TableRow,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    DialogTitle,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import BackButton from '../../../components/BackButton'
import api from '../../../Services/Api'
import {
    daysDiff,
    formatDate,
    formatDateTime,
    formatXmlDate,
    getAgeByDobComplete,
} from '../../../functions'
import formatter from '../../../formatter'
import queueIcon from '@material-ui/icons/Warning'
import removedIcon from '@material-ui/icons/Delete'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Popover } from '@mui/material'
import { DESTINATIONS_CODES } from '../../../consts'
const emailEventLabels = {
    processed: 'Processado',
    delivered: 'Entregue',
    open: 'Aberto',
    click: 'Clicado',
    deferred: 'Adiado',
    bounce: 'Rejeitado',
    dropped: 'Descartado',
    spamreport: 'Marcado como spam',
    unsubscribe: 'Descadastrado',
}

const emailEventColors = {
    delivered: 'green',
    open: 'green',
    click: 'green',
    deferred: 'orange',
    bounce: 'red',
    dropped: 'red',
    spamreport: 'red',
}

export const QueueIcon = queueIcon
export const RemovedIcon = removedIcon

const insurerVoucherExamples = {
    1: 'EX-XXX/XXXXXXX-XXX',
    2: 'XXXXXXXX',
    3: 'EXX-XXX/XXXXXXXX-XXX',
    4: 'XXXXXXXX',
    5: 'XXXXXXXX/XXXXXXX',
    6: 'xxxxxxxxxx/xx',
    7: 'XXXXXXX',
    9: 'XXXXXXXXXXXXXXXXXX/COD-OPERAÇÃO',
    10: 'EXXXXX/XXXXXXXXXX-XXXX',
    11: 'XXXXXX',
    12: 'EX-XXX/XXXXXXX-XXXX',
    14: 'XXXXXXXXXXXXXXXXXX/COD-OPERAÇÃO',
    15: 'XXXXXXXX',
}

const useStyles = makeStyles({
    root: {
        '& .MuiPaper-root': {
            marginTop: 10,
            padding: 10,
        },
        '& h4': {
            marginTop: 0,
        },
    },
    actions: {
        justifyContent: 'start', //botoes de ação na esquerda da tela
        '& button': {
            margin: 5,
        },
        '& a': {
            margin: 5,
        },
    },
    statusInput: {
        color: 'red',
    },
    warningInput: {
        color: 'orange',
    },
    successInput: {
        color: 'green',
    },
    headerCell: {
        padding: '10px',
    },
    rowCell: {
        backgroundColor: 'red',
        padding: '10px',
    },
    hidePlaceholder: {
        '& input::placeholder': {
            color: 'transparent',
        },
    },
})

export const OrderFilter = (props) => {
    const [insurerOptions, setInsurerOptions] = React.useState([])
    const [labelOptions, setLabelOptions] = React.useState([])

    useEffect(() => {
        ;(async () => {
            try {
                const result = await api.get(`admin/insurers`)
                setInsurerOptions(result.data)
            } catch (error) {
                console.log('Erro ao consultar insurers', error)
            }
        })()
        ;(async () => {
            try {
                const result = await api.get(`admin/labels`)
                setLabelOptions(result.data)
            } catch (error) {
                console.log('Erro ao consultar labels', error)
            }
        })()
    }, [])

    return (
        <Filter {...props}>
            <TextInput label="Nro Pedido" source="id" alwaysOn />
            <TextInput label="Código Voucher" source="voucher" alwaysOn />
            <TextInput label="Email Cliente" source="ownerEmail" alwaysOn />
            <TextInput label="Nome Cliente" source="ownerName" alwaysOn />
            <TextInput label="Nome Segurado" source="name" alwaysOn />
            <TextInput label="E-mail Emissor" source="travelAgent" alwaysOn />
            <TextInput label="CPF Segurado" source="cpf" />
            <TextInput label="Razão Social" source="corporateName" />
            <TextInput label="Source" source="source" />
            <DateInput
                label="Data Ínício Pedido"
                source="startDate"
                style={{ width: 180 }}
            />
            <DateInput
                label="Data Fim Pedido"
                source="endDate"
                style={{ width: 180 }}
            />
            <SelectInput
                label="Seguradora"
                source="insurerId"
                choices={insurerOptions}
            />
            <SelectInput
                label="Situação"
                source="status"
                choices={[
                    { id: 11, name: 'Aguardando Pagamento' },
                    { id: 1, name: 'Aguardando Processamento' },
                    { id: 2, name: 'Pagamento Pré-aprovado' },
                    { id: 3, name: 'Pagamento Aprovado' },
                    { id: 6, name: 'Pendente/Antifraude' },
                    { id: 10, name: 'Pendente/Erro Pré-Pagamento' },
                    { id: 7, name: 'Pendente/Erro Pagamento' },
                    { id: 8, name: 'Pendente/Erro Reserva' },
                    { id: 4, name: 'Reservado' },
                    { id: 5, name: 'Concluído' },
                    { id: 12, name: 'Cancelado/Erro Estorno' },
                    { id: 13, name: 'Cancelado/Erro Voucher' },
                    { id: 9, name: 'Cancelado/Total' },
                    { id: 14, name: 'Removido' },
                ]}
                alwaysOn
            />
            <TextInput label="Código Cupom" source="coupon" />
            <TextInput
                label="Campanha Afiliado (cupom ou utm)"
                source="campaign"
            />
            <SelectInput label="Label" source="label" choices={labelOptions} />
            <SelectInput
                label="Tipo de Pagamento"
                source="paymentType"
                choices={[
                    { id: 'Invoice', name: 'Faturado' },
                    { id: 'CreditCard', name: 'Cartão de Credito' },
                    { id: 'Transfer', name: 'Pix' },
                    { id: 'Link', name: 'Link de pagamento' },
                    { id: 'samsungpay', name: 'Samsung Pay' },
                    { id: 'applepay', name: 'Apple Pay' },
                ]}
                alwaysOn
            />
        </Filter>
    )
}

export const AssistanceOrderList = (props) => {
    const classes = useStyles()
    // const [showMore, setShowMore] = useState(false);

    const StatusField = ({ record, source }) => {
        console.log(record, source)
        return (
            <span
                className={
                    record.status === 5
                        ? classes.successInput
                        : record.status === 12 &&
                          record.Payments[0].type === 'Invoice' &&
                          classes.warningInput
                        ? record.status === 12 &&
                          record.Payments[0].type === 'Invoice' &&
                          classes.warningInput
                        : [6, 7, 8, 9, 10, 12, 13, 14].includes(
                              record.status
                          ) && classes.statusInput
                }
            >
                {record[source]}
            </span>
        )
    }

    const MyDatagridRow = ({ record, resource, id, children, basePath }) => (
        <TableRow key={id}>
            {React.Children.map(children, (field) => {
                let style = { padding: '10px' }
                if (
                    field.props.source === 'checkIn' ||
                    field.props.source === 'checkOut' ||
                    field.props.source === 'id'
                )
                    style.width = '75px'

                if (field.props.source === 'total') {
                    style.textAlign = 'left'
                    style.width = '100px'
                    style.minWidth = '100px'
                }

                if (field.props.source === 'roomsCount') {
                    style.width = '50px'
                    style.textAlign = 'center'
                }

                if (field.props.source === 'reservationId')
                    style.width = '150px'

                if (field.props.source === 'statusText') style.width = '200px'

                return (
                    <TableCell
                        key={`${id}-${field.props.source}`}
                        style={style}
                    >
                        {React.cloneElement(field, {
                            record,
                            basePath,
                            resource,
                        })}
                    </TableCell>
                )
            })}
        </TableRow>
    )

    const MyDatagridBody = (props) => (
        <DatagridBody {...props} row={<MyDatagridRow />} />
    )

    const MyDatagrid = (props) => (
        <Datagrid {...props} body={<MyDatagridBody />} />
    )

    const IdLink = (e) => {
        return <Link to={`/admin/assistanceOrders/${e.id}/show`}>{e.id}</Link>
    }

    const SelectedChip = () => {
        // const { selectedIds, onToggleItem } = useListContext();
        const record = useRecordContext()
        console.log(record)
        return (
            // <a href={`/admin/assistanceOrders`}>
            <ChipField
                source="shortName"
                clickable={false}
                // disabled={true}
                // clickable
                onClick={() => {
                    // window.location.href = `/admin/assistanceOrders/${record.id}/show`;
                    return
                }}
                style={{
                    pointerEvents: 'none',
                    backgroundColor: record.backgroundColor,
                    color: record.fontColor,
                }}
            />
            // </a>
        )
    }

    const FormatPassengers = ({ event }) => {
        const [anchorEl, setAnchorEl] = useState(null)

        const handleClick = (event) => {
            setAnchorEl(event.currentTarget)
        }

        const handleClose = () => {
            setAnchorEl(null)
        }

        const open = Boolean(anchorEl)
        const id = open ? 'simple-popover' : undefined
        const totalPassengers = event?.Passengers.length - 1

        return (
            <div>
                <div> {event?.Passengers[0]?.name}</div>
                <div onClick={handleClick}>
                    {totalPassengers > 0 ? `+${totalPassengers}` : ''}
                </div>

                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <div style={{ padding: '10px' }}>
                        {event?.Passengers.slice(1).map((passenger) => (
                            <p>{passenger.name}</p>
                        ))}
                    </div>
                </Popover>
            </div>
        )
    }

    return (
        <List
            {...props}
            title="Lista de Pedidos"
            bulkActionButtons={false}
            sort={{ field: 'id', order: 'DESC' }}
            filters={<OrderFilter />}
            perPage={25}
        >
            <MyDatagrid classes={{ headerCell: classes.headerCell }}>
                <TextFieldRa source="createdAt" label="Data do Pedido" />
                <FunctionField label="Pedido" render={IdLink} />
                <RichTextField
                    source="vouchers"
                    label="Voucher"
                    sortable={false}
                />
                <StatusField
                    source="statusText"
                    sortBy="status"
                    label="Situação"
                    sortable={false}
                />
                {/* <TextFieldRa
                    source="fraudPreventionStatusText"
                    sortBy="fraudPreventionStatus"
                    label="Anti Fraude"
                /> */}
                {/* <TextFieldRa source="Insurer.name" label="Seguradora" sortable={false} /> */}
                {/* <TextFieldRa source="reservationAt" label="Emissão" /> */}
                <TextFieldRa source="checkIn" label="Início Ap." />
                <TextFieldRa source="checkOut" label="Fim Ap." />
                <TextFieldRa
                    source="destination"
                    label="Destino"
                    sortable={false}
                />
                <FunctionField
                    // value={passengers}
                    label="Segurado(s)"
                    sortable={false}
                    render={(record) => <FormatPassengers event={record} />}
                />
                <TextFieldRa
                    source="total"
                    sortBy="total"
                    label="Total"
                    textAlign="left"
                />
                <TextFieldRa
                    source="source"
                    label="Source"
                    sortable={false}
                    style={{ maxWidth: 150 }}
                />
                <TextFieldRa
                    source="TravelAgent.email"
                    label="Agente Em."
                    sortable={false}
                    style={{ maxWidth: 150 }}
                />
                <ArrayField
                    source="labels"
                    clickable={false}
                    style={{ pointerEvents: 'none' }}
                >
                    <SingleFieldList>
                        <SelectedChip />
                    </SingleFieldList>
                </ArrayField>
                <ShowButton label="" />
            </MyDatagrid>
        </List>
    )
}

export const AssistanceOrderListQueue = (props) => {
    const classes = useStyles()

    const StatusField = ({ record, source }) => {
        return (
            <span
                className={
                    record.status === 5
                        ? classes.successInput
                        : record.status === 12 &&
                          record.Payments[0].type === 'Invoice' &&
                          classes.warningInput
                        ? record.status === 12 &&
                          record.Payments[0].type === 'Invoice' &&
                          classes.warningInput
                        : [6, 7, 8, 9, 10, 12, 13, 14].includes(
                              record.status
                          ) && classes.statusInput
                }
            >
                {record[source]}
            </span>
        )
    }

    const IdField = ({ record, source }) => {
        let messages = ''
        if (record.extraRequests) messages += 'Possui solicitação extra.'
        if (record.supplierPayment === 'Pré-Pagamento')
            messages += 'Pré-Pagamento ao Hotel.'

        if (messages)
            return (
                <Tooltip title={<div>{messages}</div>}>
                    <span>{record[source]}*</span>
                </Tooltip>
            )
        return (
            <span>
                {record[source]}
                {messages ? '*' : ''}
            </span>
        )
    }

    const MyDatagridRow = ({ record, resource, id, children, basePath }) => (
        <TableRow key={id}>
            {React.Children.map(children, (field) => {
                let style = { padding: '10px' }
                if (
                    field.props.source === 'checkIn' ||
                    field.props.source === 'checkOut' ||
                    field.props.source === 'id'
                )
                    style.width = '75px'

                if (field.props.source === 'total') {
                    style.textAlign = 'left'
                    style.width = '100px'
                    style.minWidth = '100px'
                }

                if (field.props.source === 'roomsCount') {
                    style.width = '50px'
                    style.textAlign = 'center'
                }

                if (field.props.source === 'reservationId')
                    style.width = '150px'

                if (field.props.source === 'statusText') style.width = '200px'

                return (
                    <TableCell
                        key={`${id}-${field.props.source}`}
                        style={style}
                    >
                        {React.cloneElement(field, {
                            record,
                            basePath,
                            resource,
                        })}
                    </TableCell>
                )
            })}
        </TableRow>
    )

    const MyDatagridBody = (props) => (
        <DatagridBody {...props} row={<MyDatagridRow />} />
    )
    const MyDatagrid = (props) => (
        <Datagrid {...props} body={<MyDatagridBody />} />
    )

    const MyButton = ({ record, source }) => {
        // console.log(record,source);
        return (
            <Button
                class=""
                component={Link}
                to={{ pathname: `/admin/assistanceOrders/${record.id}/show` }}
                target="_blank"
            >
                Pedido #{record.id}
            </Button>
        )
    }

    return (
        <List
            {...props}
            title="Pedidos em Fila"
            bulkActionButtons={false}
            sort={{ field: 'id', order: 'DESC' }}
            filters={<OrderFilter />}
            perPage={25}
        >
            <MyDatagrid classes={{ headerCell: classes.headerCell }}>
                <TextFieldRa source="createdAt" label="Data do Pedido" />
                <IdField source="id" label="Pedido" />
                <RichTextField
                    source="vouchers"
                    label="Voucher"
                    sortable={false}
                />
                <StatusField
                    source="statusText"
                    sortBy="status"
                    label="Situação"
                />
                {/* <TextFieldRa
                    source="fraudPreventionStatusText"
                    sortBy="fraudPreventionStatus"
                    label="Anti Fraude"
                /> */}
                <TextFieldRa
                    source="Insurer.name"
                    label="Seguradora"
                    sortable={false}
                />
                <TextFieldRa source="reservationAt" label="Emissão" />
                <TextFieldRa source="checkIn" label="Início" />
                <TextFieldRa source="checkOut" label="Fim" />
                <TextFieldRa
                    source="destination"
                    label="Destino"
                    sortable={false}
                />
                <RichTextField
                    source="passengers"
                    label="Segurado(s)"
                    sortable={false}
                />
                <TextFieldRa source="total" />
                <TextFieldRa
                    source="TravelAgent.email"
                    label="Agente"
                    sortable={false}
                />
                {/* <ShowButton/> */}
                {/* <OrderUrlField label="Pedido" source="id" target="_blank" rel="noopener noreferrer"/> */}
                <MyButton source="id" label="Ver Pedido" />
            </MyDatagrid>
        </List>
    )
}

export const AssistanceOrderListRemoved = (props) => {
    const classes = useStyles()

    const StatusField = ({ record, source }) => {
        return (
            <span
                className={
                    record.status === 5
                        ? classes.successInput
                        : record.status === 12 &&
                          record.Payments[0].type === 'Invoice' &&
                          classes.warningInput
                        ? record.status === 12 &&
                          record.Payments[0].type === 'Invoice' &&
                          classes.warningInput
                        : [6, 7, 8, 9, 10, 12, 13, 14].includes(
                              record.status
                          ) && classes.statusInput
                }
            >
                {record[source]}
            </span>
        )
    }

    const IdField = ({ record, source }) => {
        let messages = ''
        if (record.extraRequests) messages += 'Possui solicitação extra.'
        if (record.supplierPayment === 'Pré-Pagamento')
            messages += 'Pré-Pagamento ao Hotel.'

        if (messages)
            return (
                <Tooltip title={<div>{messages}</div>}>
                    <span>{record[source]}*</span>
                </Tooltip>
            )
        return (
            <span>
                {record[source]}
                {messages ? '*' : ''}
            </span>
        )
    }

    const MyDatagridRow = ({ record, resource, id, children, basePath }) => (
        <TableRow key={id}>
            {React.Children.map(children, (field) => {
                let style = { padding: '10px' }
                if (
                    field.props.source === 'checkIn' ||
                    field.props.source === 'checkOut' ||
                    field.props.source === 'id'
                )
                    style.width = '75px'

                if (field.props.source === 'total') {
                    style.textAlign = 'left'
                    style.width = '100px'
                    style.minWidth = '100px'
                }

                if (field.props.source === 'roomsCount') {
                    style.width = '50px'
                    style.textAlign = 'center'
                }

                if (field.props.source === 'reservationId')
                    style.width = '150px'

                if (field.props.source === 'statusText') style.width = '200px'

                return (
                    <TableCell
                        key={`${id}-${field.props.source}`}
                        style={style}
                    >
                        {React.cloneElement(field, {
                            record,
                            basePath,
                            resource,
                        })}
                    </TableCell>
                )
            })}
        </TableRow>
    )

    const MyDatagridBody = (props) => (
        <DatagridBody {...props} row={<MyDatagridRow />} />
    )
    const MyDatagrid = (props) => (
        <Datagrid {...props} body={<MyDatagridBody />} />
    )

    const MyButton = ({ record, source }) => {
        // console.log(record,source);
        return (
            <Button
                class=""
                component={Link}
                to={{ pathname: `/admin/assistanceOrders/${record.id}/show` }}
                target="_blank"
            >
                Pedido #{record.id}
            </Button>
        )
    }

    return (
        <List
            {...props}
            title="Pedidos em Fila"
            bulkActionButtons={false}
            sort={{ field: 'id', order: 'DESC' }}
            filters={<OrderFilter />}
            perPage={25}
        >
            <MyDatagrid classes={{ headerCell: classes.headerCell }}>
                <TextFieldRa source="createdAt" label="Data do Pedido" />
                <IdField source="id" label="Pedido" />
                <RichTextField
                    source="vouchers"
                    label="Voucher"
                    sortable={false}
                />
                <StatusField
                    source="statusText"
                    sortBy="status"
                    label="Situação"
                />
                {/* <TextFieldRa
                    source="fraudPreventionStatusText"
                    sortBy="fraudPreventionStatus"
                    label="Anti Fraude"
                /> */}
                <TextFieldRa
                    source="Insurer.name"
                    label="Seguradora"
                    sortable={false}
                />
                <TextFieldRa source="reservationAt" label="Emissão" />
                <TextFieldRa source="checkIn" label="Início" />
                <TextFieldRa source="checkOut" label="Fim" />
                <TextFieldRa
                    source="destination"
                    label="Destino"
                    sortable={false}
                />
                <RichTextField
                    source="passengers"
                    label="Segurado(s)"
                    sortable={false}
                />
                <TextFieldRa source="total" />
                <TextFieldRa
                    source="TravelAgent.email"
                    label="Agente"
                    sortable={false}
                />
                {/* <ShowButton/> */}
                {/* <OrderUrlField label="Pedido" source="id" target="_blank" rel="noopener noreferrer"/> */}
                <MyButton source="id" label="Ver Pedido" />
            </MyDatagrid>
        </List>
    )
}

export const AssistanceOrderEdit = (props) => {
    const location = useLocation()

    const redirect = (basePath, id, data) =>
        `/admin/assistanceOrders/${data.id}/show`

    const transform = (data) => ({
        ...data,
        type: location.state.type,
    })

    const validateDates = (values) => {
        const errors = {}
        const checkIn = new Date(values.checkInEdit)
        const checkOut = new Date(values.checkOutEdit)

        if (checkOut <= checkIn) {
            errors.checkOutEdit =
                'A data de saída deve ser maior que a data de entrada'
        }

        return errors
    }

    if (
        location.state &&
        location.state.type &&
        location.state.type === 'dates'
    )
        return (
            <Edit
                title="Alterar período da reserva"
                {...props}
                mutationMode="pessimistic"
                transform={transform}
            >
                <SimpleForm redirect={redirect} validate={validateDates}>
                    <DateInput
                        label="Entrada"
                        source="checkInEdit"
                        inputProps={{
                            min: formatXmlDate(new Date()),
                        }}
                    />
                    <DateInput
                        label="Saída"
                        source="checkOutEdit"
                        inputProps={{
                            min: formatXmlDate(new Date()),
                        }}
                    />
                </SimpleForm>
            </Edit>
        )
    else return null
}

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    )
}

export const AssistanceOrderShow = ({ permissions, ...props }) => {
    const { record } = useShowController(props)

    const checkAuth = useCheckAuth()
    const handleCheckAuth = () => checkAuth()
    const notify = useNotify()
    const refresh = useRefresh()

    const classes = useStyles()

    const [value, setValue] = React.useState(0)
    const [emailVoucher, setEmailVoucher] = React.useState(null)
    const [comment, setComment] = React.useState(null)
    const [commentModalOpen, setCommentModalOpen] = React.useState(false)
    const [sendVoucherModalOpen, setSendVoucherModalOpen] =
        React.useState(false)
    const [forceBookingModalOpen, setforceBookingModalOpen] =
        React.useState(false)
    const [cancelVoucherModalOpen, setCancelVoucherModalOpen] =
        React.useState(false)
    const [voucherToCancel, setVoucherToCancel] = React.useState(null)
    const [cancelOrderModalOpen, setCancelOrderModalOpen] =
        React.useState(false)
    const [cancelPartialOrderModalOpen, setCancelPartialOrderModalOpen] =
        React.useState(false)
    const [orderToCancel, setOrderToCancel] = React.useState(null)
    const [removeOrderModalOpen, setRemoveOrderModalOpen] =
        React.useState(false)
    const [orderToRemove, setOrderToRemove] = React.useState(null)
    const [forceCancelModalOpen, setforceCancelModalOpen] =
        React.useState(false)
    const [forceCancelPartialModalOpen, setforceCancelPartialModalOpen] =
        React.useState(false)
    const [issuedManuallyFirstStep, setIssuedManuallyFirstStep] =
        React.useState(false)
    const [issuedManuallySecondStep, setIssuedManuallySecondStep] =
        React.useState(false)
    const [removeTagModalOpen, setRemoveTagModalOpen] = React.useState(false)
    const [tagToRemove, setTagToRemove] = React.useState(null)
    const [sendGateModalOpen, setSendGateModalOpen] = React.useState(false)
    // const [orderToGate, setOrderToGate] = React.useState(null);
    const [newTag, setNewTag] = React.useState('')
    const [openNewTagDialog, setOpenNewTagDialog] = React.useState(false)
    const [tagOptions, setTagOptions] = React.useState([])
    const [users, setUserOptions] = React.useState([])
    const [orderInfo, setOrderInfo] = React.useState()
    const [openNewAgentDialog, setOpenNewAgentDialog] = React.useState(false)
    const [newAgent, setNewAgent] = React.useState('')
    const [paymentModalOpen, setPaymentModalOpen] = React.useState(false)
    const [newPayment, setNewPayment] = React.useState('')
    const [gateXml, setGateXml] = React.useState('')
    const [emailLogs, setEmailLogs] = React.useState([])
    const [emailPreview, setEmailPreview] = React.useState(null)
    const [imgFile, setImgFile] = React.useState(null)
    const [paymentId, setPaymentId] = React.useState()
    const [forceResendOrderEmailModalOpen, setForceResendOrderEmailModalOpen] =
        React.useState(false)
    const [orderId, setOrderId] = React.useState()
    const [orderEmail, setOrderEmail] = React.useState()
    const [voucherCodes, setVoucherCodes] = React.useState([])
    const [passengersVouchers, setPassengersVouchers] = React.useState([])
    const [mainlyCancelVoucherModal, setMainlyCancelVoucherModal] =
        React.useState(false)
    const [cancelIndividualVoucherModal, setCancelIndividualVoucherModal] =
        React.useState(false)
    const [
        cancelIndividualVoucherErrorModal,
        setCancelIndividualVoucherErrorModal,
    ] = React.useState(false)
    const [paxIndividualIndex, setPaxIndividualIndex] = React.useState(null)
    const [voucherStatusData, setVoucherStatusData] = useState()
    const [verifyVoucherIsCancelledModal, setVerifyVoucherIsCancelledModal] =
        useState(false)
    const [vouchersCanceledList, setVouchersCanceledList] = useState([])
    const [issuedVoucherFirstStepModal, setIssuedVoucherFirstStepModal] =
        useState(false)
    const [attachmentManuallyFirstStep, setAttachmentManuallyFirstStep] =
        useState(false)
    const [attachmentManuallySecondStep, setAttachmentManuallySecondStep] =
        useState(false)
    const [products, setProducts] = useState([])
    const [markup, setMarkup] = useState(0)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [productId, setProductId] = useState()
    const [product, setProduct] = useState()
    const [passengerId, setPassengerId] = useState()

    const [passengerCep, setPassengerCep] = useState()
    const [passengerAddress, setPassengerAddress] = useState()
    const [passengerState, setPassengerState] = useState()
    const [passengerComplement, setPassengerComplement] = useState()
    const [passengerNumber, setPassengerNumber] = useState()
    const [passengerDistrict, setPassengerDistrict] = useState()
    const [passengerCity, setPassengerCity] = useState()

    const [passengerNewVoucherData, setPassengerNewVoucherData] = useState([])
    const [heroVoucherEdits, setHeroVoucherEdits] = useState({})
    const canEditHeroVoucher =
        orderInfo?.Insurer?.id === 9 &&
        permissions?.includes('assistanceadmin')

    const [isChecked, setIsChecked] = useState(false)

    const [recordData, setRecordData] = useState()

    const [updateOwnerDateModal, setUpdateOwnerDateModal] = useState(false)

    useEffect(() => {
        if (markup <= record?.total) setIsChecked(true)
    }, [markup])

    const handleInputChangeNewVoucherData = (index, field, value) => {
        setPassengerNewVoucherData((prev) => {
            const updated = [...prev]
            updated[index][field] = value
            return updated
        })
    }

    const combinedInsurersIds = [5, 7]

    const handleMainlyCancelVoucherModal = (orderId) => {
        getAllVouchersCanceledList(orderId)
        setMainlyCancelVoucherModal(true)
    }

    const setCancelIndividualVoucherModalFunction = (paxIndex) => {
        setCancelIndividualVoucherModal(true)
        setPaxIndividualIndex(paxIndex)
    }

    //AQUI NOVA FUNÇÃO
    const updatePassengerInRecord = (index, updatedPassenger) => {
        setRecordData((prev) => {
            if (!prev) return prev

            const updatedPassengers = [...prev.Passengers]
            updatedPassengers[index] = updatedPassenger

            return {
                ...prev,
                Passengers: updatedPassengers,
            }
        })
    }

    const updateRecordAddressField = (field, value) => {
        setRecordData((prev) => ({
            ...prev,
            [field]: value,
        }))
    }

    //!TESTAR ISSO AQUI, CUIDADO PARA NÃO TESTAR NO PEDIDO DOS OUTROS!
    const cancelPassengerVoucher = async (insurerId, vouchers) => {
        try {
            await api.put(`/admin/insurers/${insurerId}/cancelVouchers`, {
                vouchers: [vouchers],
                orderId: record?.id,
            })
            // throw new Error("Mock - Erro de cancelamento do voucher")
            setCancelIndividualVoucherModal(false)
            notify('Voucher cancelado com sucesso.', 'success')
            refresh()
        } catch (error) {
            notify('Erro ao cancelar voucher.', 'error')
            refresh()
            setCancelIndividualVoucherModal(false)
            setCancelIndividualVoucherErrorModal(true)
        }
    }

    //? Função para ver o status do pedido no modal de cancelamento individual do voucher
    const verifyVoucherStatus = async (insurerId, voucher) => {
        try {
            const response = await api.post(`/admin/insurers/${insurerId}`, {
                vouchersId: ['13376911'],
            })

            const responseData = response?.data?.data
            console.log(responseData)
            setVoucherStatusData(responseData[0])
            setVerifyVoucherIsCancelledModal(true)
        } catch (error) {
            notify('Falha ao consultar o status do voucher.', 'error')
            refresh()
        }
    }

    //?Função para pegar a lista de vouchers cancelados por pedido
    const getAllVouchersCanceledList = async (orderId) => {
        try {
            const response = await api.get(
                `/admin/orders/${orderId}/cancelVouchers`
            )

            const responseData = response?.data?.data

            console.log(responseData)

            setVouchersCanceledList(responseData)
        } catch (error) {
            notify('Falha ao consultar lista de vouchers cancelados.', 'error')
            refresh()
        }
    }

    //? PEGAR OS PLANOS DOS SEGUROS
    const getListPlans = async () => {
        try {
            const { data } = await api.post(`/assistance/search`, {
                startDate: startDate,
                ages: [getAgeByDobComplete(record?.Passengers[0]?.dob) || 25],
                destination: DESTINATIONS_CODES[record?.destination],
                endDate: endDate,
                renew: false,
                coupon: record?.coupon,
                orderBy: 'DSC',
                insurerId: record?.Insurer?.id,
            })

            console.log('o record daqui oh:', record)

            console.log({ data })

            const products = data.products.map((product) => ({
                id: product?.id,
                name: product?.description,
                // markup: product?.fare?.fareTotal - product?.fare?.discount
            }))

            setProducts(products)

            console.log({ products })

            console.log({ startDate })
            console.log({ endDate })

            notify('Planos carregados com sucesso.', 'success')
        } catch (error) {
            notify('Falha ao consultar os planos.', 'error')
            refresh()
        }
    }

    //? PEGAR DETALHES DO PRODUTO
    const getProductById = async (id) => {
        console.log(
            'as idades aqui:',
            record?.Passengers.map((passenger) =>
                getAgeByDobComplete(
                    new Date(passenger?.dob).toISOString().slice(0, 10)
                )
            )
        )
        console.log(record?.Passengers.map((passenger) => passenger?.dob))

        try {
            const { data } = await api.post(`/assistance/search`, {
                startDate: startDate,
                ages: record?.Passengers.map((passenger) =>
                    getAgeByDobComplete(
                        new Date(passenger?.dob).toISOString().slice(0, 10)
                    )
                ),
                destination: DESTINATIONS_CODES[record?.destination],
                endDate: endDate,
                renew: false,
                coupon: record?.coupon,
                orderBy: 'DSC',
                insurerId: record?.Insurer?.id,
                productId: id,
            })

            console.log({ data })

            const product = {
                id: data?.products[0]?.id,
                productCode: data?.products[0]?.productCode,
                fareCode: data?.products[0]?.fareCode,
            }

            const productMarkup =
                data?.products[0]?.fare?.fareTotal -
                data?.products[0]?.fare?.discount

            console.log({ product })
            console.log({ productMarkup })

            setMarkup(productMarkup)
            setProduct(product)
        } catch (error) {
            notify('Falha ao consultar os planos.', 'error')
            refresh()
        }
    }

    //? EMITIR NOVO VOUCHER
    const issuedNewVoucher = async () => {
        try {
            await api.post(`/admin/orders/${record?.id}/newVouchers`, {
                passengerId: passengerId,
                productId: product?.id,
                productCode: product?.productCode,
                productFareCode: product?.fareCode,
                address: {
                    address: passengerAddress,
                    cep: passengerCep,
                    city: passengerCity,
                    complement: passengerComplement,
                    district: passengerDistrict,
                    number: passengerNumber,
                    state: passengerState,
                },
                passengersData: passengerNewVoucherData,
                startDate: startDate,
                endDate: endDate,
            })

            console.log({ passengerId })
            console.log({ product })

            notify('Voucher emitido com sucesso.', 'success')
            refresh()
        } catch (error) {
            console.log(error)
            notify('Falha ao emitir novo voucher.', 'error')
            refresh()
        }
    }

    const handleVoucherChange = (index, value) => {
        setVoucherCodes((prev) => {
            const updatedVouchers = [...prev]
            updatedVouchers[index] = value
            return updatedVouchers
        })
    }

    const addVoucherCode = async (insurerId) => {
        console.log({ voucherCode: voucherCodes })
        try {
            const { data } = await api.post(`admin/insurers/${insurerId}`, {
                vouchersId: voucherCodes,
                orderId: record?.id,
            })

            setPassengersVouchers(data?.data)

            setIssuedManuallySecondStep(true)

            console.log({ data })
        } catch (error) {
            notify('Voucher não encontrado! Tente novamente.', 'warning')
        }
    }

    const addAttachmentVoucherCode = async (insurerId) => {
        console.log({ voucherCode: voucherCodes })
        try {
            const { data } = await api.post(`admin/insurers/${insurerId}`, {
                vouchersId: voucherCodes,
            })

            setPassengersVouchers(data?.data)

            setAttachmentManuallySecondStep(true)

            console.log({ data })
        } catch (error) {
            notify('Voucher não encontrado! Tente novamente.', 'warning')
        }
    }

    const handleUpdateOwnerData = async () => {
        try {
            await api.patch(`/admin/orders/updateOwner/${record.id}`, {
                ownerName: recordData?.ownerName,
                ownerDob: recordData?.ownerDob,
                ownerPhone: recordData?.ownerPhone,
                ownerEmail: recordData?.ownerEmail,
                ownerAddress: recordData?.ownerAddress,
                ownerNumber: recordData?.ownerNumber,
                ownerComplement: recordData?.ownerComplement,
                ownerDistrict: recordData?.ownerDistrict,
                ownerCity: recordData?.ownerCity,
                ownerState: recordData?.ownerState,
                ownerCep: recordData?.ownerCep,
                emergencyName: recordData?.emergencyName,
                emergencyPhone: recordData?.emergencyPhone,
                emergencyCellphone: recordData?.emergencyCellphone,
            })
            notify('Dados atualizados com sucesso.', 'success')
            refresh()
        } catch (error) {
            notify('Erro ao atualizar dados.', 'error')
            refresh()
        }
    }
    const handleUpdateVoucherPassengers = async (orderId, passengerData) => {
        const passengerDataMapped = passengerData.map((passenger, index) => ({
            id: passenger?.id,
            voucher: passengersVouchers[index]?.voucher,
            voucherStatus: passengersVouchers[index]?.status
                ? 'Emitido'
                : 'Falha',
            voucherUrl: passengersVouchers[index]?.voucherUrl,
            voucherUrlEn: passengersVouchers[index]?.voucherUrlEn,
        }))

        try {
            const { data } = await api.put('/admin/passengers/vouchers', {
                orderId,
                passengersData: passengerDataMapped,
            })

            notify('Vouchers atualizados com sucesso!', 'success')

            setIssuedManuallySecondStep(false)
            setIssuedManuallyFirstStep(false)

            console.log({ data })
        } catch (error) {
            notify('Voucher não encontrado! Tente novamente.', 'warning')
        }
    }

    const handleHeroVoucherChange = (paxId, field, value) => {
        setHeroVoucherEdits((prev) => ({
            ...prev,
            [paxId]: { ...prev[paxId], [field]: value },
        }))
    }

    const handleSaveHeroVoucher = async (pax) => {
        const edits = heroVoucherEdits[pax.id] || {}
        const payload = Object.fromEntries(
            Object.entries(edits).filter(
                ([field, value]) => value !== (pax[field] ?? '')
            )
        )

        if (!Object.keys(payload).length) {
            notify('Nenhuma alteração para salvar.', 'warning')
            return
        }

        try {
            await api.patch(`/admin/passengers/${pax.id}/voucher`, payload)

            setOrderInfo((prev) => ({
                ...prev,
                Passengers: prev.Passengers.map((passenger) =>
                    passenger.id === pax.id
                        ? { ...passenger, ...payload }
                        : passenger
                ),
            }))
            setHeroVoucherEdits((prev) => {
                const { [pax.id]: _, ...rest } = prev
                return rest
            })

            notify('Voucher atualizado com sucesso!', 'success')
        } catch (error) {
            notify('Erro ao atualizar voucher.', 'error')
        }
    }

    const handleUpdateAttachmentVoucherPassengers = async (
        orderId,
        passengerData
    ) => {
        const passengerDataMapped = passengerData.map((passenger, index) => ({
            id: passenger?.id,
            voucher: passengersVouchers[index]?.voucher,
            voucherStatus: passengersVouchers[index]?.status
                ? 'Emitido'
                : 'Falha',
            voucherUrl: passengersVouchers[index]?.voucherUrl,
            voucherUrlEn: passengersVouchers[index]?.voucherUrlEn,
        }))

        try {
            const { data } = await api.put('/admin/passengers/vouchers', {
                orderId,
                passengersData: passengerDataMapped,
            })

            notify('Vouchers anexados com sucesso!', 'success')
            refresh()

            setAttachmentManuallySecondStep(false)
            setAttachmentManuallyFirstStep(false)

            console.log({ data })
        } catch (error) {
            notify('Voucher não encontrado! Tente novamente.', 'warning')
        }
    }

    const handleFile = (event) => {
        if (!event.target.files) return

        const productImage = event.target.files[0]

        if (!productImage) return

        if (
            productImage.type === 'image/png' ||
            productImage.type === 'image/jpeg' ||
            productImage.type === 'application/pdf'
        ) {
            setImgFile(productImage)
        } else {
            notify(
                'Formato de arquivo não suportado, tente os tipos png,jpeg ou pdf',
                'warning'
            )
            refresh()
        }
    }

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader()
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result)
            }
            fileReader.onerror = (error) => {
                reject(error)
            }
        })
    }

    const uploadAttachment = async (orderId) => {
        if (!imgFile) return

        const base64 = await convertToBase64(imgFile)

        try {
            await handleCheckAuth()
            const { data: uploadAttachmentData } = await api.post(
                '/admin/uploads/attachment',
                {
                    imageFile64: base64,
                    imageType: imgFile.type,
                    imageName: imgFile.name,
                }
            )

            const path = uploadAttachmentData.data.path

            const { data: getAttachmentData } = await api.post(
                '/admin/uploads/getAttachment',
                { path }
            )

            const attachment = getAttachmentData.data.url

            const { data: updateAttachmentData } = await api.put(
                `/admin/payment/${orderId}`,
                { attachment }
            )

            if (
                uploadAttachmentData.success &&
                getAttachmentData.success &&
                updateAttachmentData.success
            ) {
                notify('Upload do comprovante com sucesso.!', 'success')
                refresh()
            } else {
                notify('Erro ao fazer upload do comprovante', 'warning')
                refresh()
            }
        } catch (error) {
            console.log('Erro ao fazer upload do comprovante')
        }
    }

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    const sendVoucher = async (orderId, email) => {
        try {
            await handleCheckAuth()
            const result = await api.post(`/voucher/${orderId}`, {
                email: email,
            })
            if (result.data.success) {
                notify('Voucher enviado com sucesso!', 'success')
                refresh()
            } else throw new Error()
        } catch (error) {
            console.log('erro ao reenviar voucher', error)
            notify('Erro ao enviar voucher!', 'warning')
            refresh()
        }
    }

    const addComment = async (orderId, comment) => {
        try {
            await handleCheckAuth()
            const result = await api.post(`/admin/orderComments`, {
                orderId,
                comment,
            })
            if (result.data.success) {
                notify('Comentário adicionado com sucesso!', 'success')
                refresh()
                setComment('')
            } else throw new Error()
        } catch (error) {
            console.log('erro ao reenviar comentário', error)
            notify('Erro ao enviar comentário!', 'warning')
            refresh()
        }
    }

    const cancelVoucher = async () => {
        let errorMessage = null
        try {
            await handleCheckAuth()
            const result = await api.post('/assistance/voucher/cancel', {
                voucher: voucherToCancel.voucher,
                insurer: voucherToCancel.insurer,
                cpf: voucherToCancel.cpf,
                orderId: voucherToCancel.orderId,
            })
            if (result.data.success) {
                notify('Voucher cancelado com sucesso!', 'success')
                refresh()
            } else {
                if (result.data.message) errorMessage = result.data.message
                notify(
                    `Erro ao cancelar voucher: ${
                        errorMessage ? errorMessage : ''
                    }`,
                    'warning'
                )
                refresh()
            }
        } catch (error) {
            console.log('erro ao cancelar voucher')
            notify(
                `Erro ao cancelar voucher! ${errorMessage ? errorMessage : ''}`,
                'warning'
            )
            refresh()
        }
    }

    const cancelOrder = async () => {
        let errorMessage = null
        try {
            await handleCheckAuth()
            const result = await api.post(
                `/assistance/cancel/${orderToCancel.orderId}`,
                { cancelType: 1 }
            )
            if (result.data.success) {
                notify('Pedido cancelado com sucesso!', 'success')
                refresh()
            } else {
                if (result.data.message) errorMessage = result.data.message
                notify(
                    `Erro ao cancelar pedido: ${
                        errorMessage ? errorMessage : ''
                    }`,
                    'warning'
                )
                refresh()
            }
        } catch (error) {
            console.log('erro ao cancelar pedido')
            notify(
                `Erro ao cancelar pedido! ${errorMessage ? errorMessage : ''}`,
                'warning'
            )
            refresh()
        }
    }

    const resendOrderEmail = async () => {
        try {
            await handleCheckAuth()
            await api.post('resendOrderEmail', {
                orderId: orderId,
                email: orderEmail,
            })
            notify('Email reenviado com sucesso!')
            refresh()
        } catch (error) {
            console.log('erro ao reenviar email')
            notify(
                'Erro ao reenviar email, por favor, tente novamente!',
                'warning'
            )
            refresh()
        }
    }

    const cancelPartialOrder = async () => {
        let errorMessage = null
        try {
            await handleCheckAuth()
            const result = await api.post(
                `/assistance/cancel/${orderToCancel.orderId}`,
                { cancelType: 2 }
            )
            if (result.data.success) {
                notify('Pedido cancelado parcialmente com sucesso!', 'success')
                refresh()
            } else {
                if (result.data.message) errorMessage = result.data.message
                notify(
                    `Erro ao cancelar pedido parcialmente: ${
                        errorMessage ? errorMessage : ''
                    }`,
                    'warning'
                )
                refresh()
            }
        } catch (error) {
            console.log('erro ao cancelar pedido parcial')
            notify(
                `Erro ao cancelar pedido parcialmente! ${
                    errorMessage ? errorMessage : ''
                }`,
                'warning'
            )
            refresh()
        }
    }

    const removeOrder = async () => {
        let errorMessage = null
        try {
            await handleCheckAuth()
            const result = await api.post(
                `/assistance/remove/${orderToRemove.orderId}`,
                { orderId: orderToRemove.orderId }
            )
            if (result.data.success) {
                notify('Pedido removido com sucesso!', 'success')
                refresh()
            } else {
                if (result.data.message) errorMessage = result.data.message
                notify(
                    `Erro ao remover pedido: ${
                        errorMessage ? errorMessage : ''
                    }`,
                    'warning'
                )
                refresh()
            }
        } catch (error) {
            console.log('erro ao remover pedido')
            notify(
                `Erro ao remover pedido! ${errorMessage ? errorMessage : ''}`,
                'warning'
            )
            refresh()
        }
    }

    const approveManually = async (orderId, paymentId) => {
        try {
            await handleCheckAuth()
            const result = await api.post('/approveManually', {
                orderId,
                paymentId,
            })
            if (result.data.success) {
                notify('Reserva aprovada manualmente!', 'success')
                refresh()
            } else return new Error(result?.data?.message)
        } catch (error) {
            console.log('erro ao aprovar manualmente', error)
            notify(
                `Erro ao aprovar manualmente a reserva! ${error?.response?.data?.message}`,
                'error'
            )
            refresh()
        }
    }

    const cancelManually = async (orderId) => {
        try {
            await handleCheckAuth()
            const result = await api.post('/cancelManually', {
                orderId,
                cancelType: 1,
            })
            if (result.data.success) {
                notify('Reserva cancelada manualmente!', 'success')
                refresh()
            } else throw new Error()
        } catch (error) {
            console.log('erro ao cancelada manualmente', error)
            notify(
                `Erro ao cancelada manualmente a reserva! ${JSON.stringify(
                    error
                )}`,
                'warning'
            )
            refresh()
        }
    }

    const cancelPartialManually = async (orderId) => {
        try {
            await handleCheckAuth()
            const result = await api.post('/cancelManually', {
                orderId,
                cancelType: 2,
            })
            if (result.data.success) {
                notify(
                    'Reserva cancelada manualmente de forma parcial!',
                    'success'
                )
                refresh()
            } else throw new Error()
        } catch (error) {
            console.log('erro ao cancelar manualmente de forma parcial', error)
            notify(
                `Erro ao cancelar manualmente de forma parcial! ${JSON.stringify(
                    error
                )}`,
                'warning'
            )
            refresh()
        }
    }

    const sendGate = async (orderId) => {
        try {
            await handleCheckAuth()
            const result = await api.post(`/xml/${orderId}`, {
                // email: email,
            })
            if (result.data.success) {
                notify('Enviado para Gate com sucesso!', 'success')
                refresh()
            } else throw new Error()
        } catch (error) {
            console.log('erro ao enviar para Gate', error)
            notify('Erro ao enviar para Gate!', 'warning')
            refresh()
        }
    }

    const sendToro = async (orderId) => {
        try {
            await handleCheckAuth()
            await api.post(`/assistance/toroIntegration/${orderId}`)
            notify('Pedido enviado para Toro com sucesso!', 'success')
            refresh()
        } catch (error) {
            console.log('Erro ao enviar pedido para a Toro', error)
            notify('Erro ao enviar pedido para a Toro!', 'error')
            refresh()
        }
    }

    const forceBookingModal = async (paymentId) => {
        setPaymentId(paymentId)
        setforceBookingModalOpen(true)
    }

    const forceResendEmailModal = async (orderId) => {
        setOrderId(orderId)
        setForceResendOrderEmailModalOpen(true)
    }

    const forceCancelModal = async () => {
        setforceCancelModalOpen(true)
    }

    const forceCancelPartialModal = async () => {
        setforceCancelPartialModalOpen(true)
    }

    const sendVoucherModal = async () => {
        setSendVoucherModalOpen(true)
    }

    const sendGateModal = async () => {
        setSendGateModalOpen(true)
    }

    const cancelOrderModal = async (orderId) => {
        if (orderId) {
            setOrderToCancel({ orderId })
            setCancelOrderModalOpen(true)
        } else {
            console.log('reseva sem orderId')
            notify('Reseva sem orderId', 'warning')
        }
    }

    const cancelPartialOrderModal = async (orderId) => {
        if (orderId) {
            setOrderToCancel({ orderId })
            setCancelPartialOrderModalOpen(true)
        } else {
            console.log('reseva sem orderId')
            notify('Reseva sem orderId', 'warning')
        }
    }

    const removeOrderModal = async (orderId) => {
        if (orderId) {
            setOrderToRemove({ orderId })
            setRemoveOrderModalOpen(true)
        } else {
            console.log('reseva sem orderId')
            notify('Reseva sem orderId', 'warning')
        }
    }

    const handleNewTag = async (productTags) => {
        try {
            const result = await api.get(`admin/labels`)
            productTags = productTags.map((a) => a.labelId)
            const tags = result.data.filter((a) => !productTags.includes(a.id))
            setTagOptions(tags)
            setNewTag('')
            setOpenNewTagDialog(true)
        } catch (error) {
            console.log('Erro ao consultar tags', error)
        }
    }

    const newProductTag = async (orderId) => {
        try {
            if (orderId && newTag) {
                await handleCheckAuth()
                await api.post(`admin/orderLabels`, {
                    orderId,
                    labelId: newTag,
                })
                setOpenNewTagDialog(false)
                refresh()
            } else {
                notify(`Selecione uma tag`, { type: 'error' })
            }
        } catch (error) {
            console.log('erro ao adicionar tag')
        }
    }

    const handleChangeNewTag = (value) => {
        setNewTag(value)
    }

    const removeTagModal = async (orderLabelId) => {
        if (orderLabelId) {
            setTagToRemove({ orderLabelId })
            setRemoveTagModalOpen(true)
        } else {
            console.log('tag sem id')
            notify('Tag sem id', 'warning')
        }
    }

    const removeTag = async () => {
        let errorMessage = null
        try {
            await handleCheckAuth()
            const result = await api.delete(
                `/admin/orderLabels/${tagToRemove.orderLabelId}`,
                {}
            )
            if (result.data) {
                notify('Label cancelada com sucesso!', 'success')
                refresh()
            } else {
                if (result.data.message) errorMessage = result.data.message
                notify(
                    `Erro ao cancelar label: ${
                        errorMessage ? errorMessage : ''
                    }`,
                    'warning'
                )
                refresh()
            }
        } catch (error) {
            console.log('erro ao cancelar label')
            notify(
                `Erro ao cancelar label! ${errorMessage ? errorMessage : ''}`,
                'warning'
            )
            refresh()
        }
    }

    const handleChangeNewAgent = (value) => {
        setNewAgent(value)
    }

    const newAgentOrder = async (orderId) => {
        try {
            if (orderId && newAgent) {
                await handleCheckAuth()
                await api.put(`admin/assistanceOrders/${orderId}/agent`, {
                    orderId,
                    agentId: newAgent,
                })
                setOpenNewAgentDialog(false)
                refresh()
            } else {
                notify(`Selecione um agente`, { type: 'error' })
            }
        } catch (error) {
            console.log('erro ao adicionar agente')
        }
    }

    const handleChangeNewPayment = (value) => {
        setNewPayment(value)
    }

    const addPayment = async (orderId, newPayment) => {
        try {
            await handleCheckAuth()
            if (!orderId || !newPayment) {
                notify(`Oops! Insira uma forma de pagamento!`, 'warning')
                return false
            }
            const result = await api.post('/paymentManually', {
                orderId,
                paymentType: newPayment,
            })
            if (result.data.success) {
                notify('Novo Pagamento Inserido!', 'success')
                refresh()
                if (['Manual', 'Invoice'].includes(newPayment)) {
                    setforceBookingModalOpen(true)
                }
            } else throw new Error()
        } catch (error) {
            console.log('erro ao criar Pagamento manualmente', error)
            notify(
                `Erro ao criar Pagamento manualmente! ${JSON.stringify(error)}`,
                'warning'
            )
            refresh()
        }
    }

    const getXmlGate = async (orderId) => {
        try {
            await handleCheckAuth()
            const { data } = await api.get(`/xml/preview/${orderId}`)
            setGateXml(data)
        } catch (error) {
            console.log(error)
            notify('Erro ao recuperar xml do gate!', 'warning')
            refresh()
        }
    }

    const getEmailLogs = async (orderId) => {
        try {
            await handleCheckAuth()
            const { data } = await api.get(`/emailLog/${orderId}`)
            setEmailLogs(data?.data || [])
        } catch (error) {
            console.log(error)
            notify('Erro ao recuperar histórico de e-mails!', 'warning')
        }
    }

    const changeBackgroundByPaymentStatus = (paymentStatus) => {
        const backgroundStatus = {
            'Pré-aprovado': '#fff2d4',
            Capturado: '#e2ffe7',
            Cancelado: '#ffeee4',
            'Erro Pré-Aprovar': '#ffeee4',
            'Erro Capturar': '#ffeee4',
            'Aprovado Manualmente': '#e2ffe7',
        }

        return backgroundStatus[paymentStatus]
    }

    const changeBackgroundByVoucherStatus = (voucherStatus) => {
        const backgroundStatus = {
            Emitido: '#e2ffe7',
            Cancelado: '#FFE3E3',
        }

        return backgroundStatus[voucherStatus]
    }

    const getPaymeeUrl = (url) => {
        if (!url) return 'https://secure.paymee.com.br'

        if (url.includes('apisandbox.paymee')) {
            return 'https://apisandbox.paymee.com.br'
        }

        return 'https://secure.paymee.com.br'
    }

    const getPagturTypePayment = (fop) => {
        if (!fop) return 'Link de Pgto'

        const fopType = {
            samsungpay: 'Samsung Pay',
            applepay: 'Apple Pay',
        }

        return fopType[fop]
    }

    useEffect(() => {
        ;(async () => {
            try {
                const result = await api.get(
                    `admin/users?_order=ASC&_sort=email&_start=0&role=assistanceuser`
                )
                setUserOptions(result.data)
                const resultPedidos = await api.get(
                    `admin/assistanceOrders/${record?.id}`
                )
                setOrderInfo(resultPedidos.data)
                setRecordData(resultPedidos.data)
                const formatted = resultPedidos.data?.Passengers.map((pax) => ({
                    id: pax.id,
                    name: pax.name || '',
                    cpf: pax.cpf || '',
                    dob: pax.dob || '',
                }))

                setPassengerNewVoucherData(formatted)
            } catch (error) {
                console.log('Erro ao consultar users', error)
            }
        })()
    }, [record])

    const calculateRefund = (value) => {
        const REFUND_PERCENT_VALUE = 20

        const refundTotal = (value * REFUND_PERCENT_VALUE) / 100

        return `R$ ${Number(value - refundTotal).toFixed(2)}`
    }

    if (orderInfo?.id) {
        return (
            <div className={classes.root}>
                <TopToolbar className={classes.actions}>
                    <BackButton />
                    {/* ***** */}
                    {/* Aprovar Manualmente: apenas se Pendente/Erro Reserva*/}

                    {!record?.TravelAgent?.Enterprise &&
                        8 === orderInfo?.status &&
                        permissions.includes('assistanceadmin') && (
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ backgroundColor: 'Green' }}
                                onClick={() => forceBookingModal()}
                            >
                                Emitir Vouchers
                            </Button>
                        )}

                    {record?.TravelAgent?.Enterprise?.allowManualIssuance &&
                        8 === orderInfo?.status &&
                        permissions.includes('assistanceadmin') && (
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ backgroundColor: 'Green' }}
                                onClick={() => forceBookingModal()}
                            >
                                Emitir Vouchers
                            </Button>
                        )}

                    {/* Cancelar Pedido: apenas se  Aguardando Pagamento */}
                    {[11].includes(orderInfo?.status) &&
                        permissions.includes('assistanceadmin') && (
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ backgroundColor: 'Red' }}
                                onClick={() => cancelOrderModal(orderInfo?.id)}
                            >
                                Cancelar Pedido
                            </Button>
                        )}
                    {/* Reenviar Voucher: só permite reenviar voucher e cancelar se o pedido estiver reservado ou concluído */}
                    {[4, 5].includes(orderInfo?.status) && (
                        <>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => sendVoucherModal()}
                            >
                                Reenviar Voucher
                            </Button>
                        </>
                    )}
                    {/* Estonardo Manualmente: apenas se Cancelado Erro Estorno ou cancelado Erro Voucher */}
                    {[12, 13].includes(orderInfo?.status) &&
                        permissions.includes('assistanceadmin') && (
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ backgroundColor: 'Red' }}
                                onClick={() => forceCancelModal()}
                            >
                                {orderInfo?.status === 12
                                    ? 'ESTORNADO MANUALMENTE'
                                    : 'VOUCHER CANCELADO MANUALMENTE + ESTORNAR INTEGRAL'}
                            </Button>
                        )}
                    {[12, 13].includes(orderInfo?.status) &&
                        permissions.includes('assistanceadmin') && (
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ backgroundColor: 'Tomato' }}
                                onClick={() => forceCancelPartialModal()}
                            >
                                {orderInfo?.status === 12
                                    ? 'ESTORNADO MANUALMENTE PARCIAL'
                                    : 'VOUCHER CANCELADO MANUALMENTE + ESTORNAR PARCIAL'}
                            </Button>
                        )}
                    {/* Reenviar Toro */}
                    {orderInfo?.source === 'TORO' &&
                        orderInfo?.status === 5 &&
                        permissions.includes('assistanceadmin') && (
                            <>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => sendToro(orderInfo?.id)}
                                >
                                    Reenviar Toro
                                </Button>
                            </>
                        )}
                </TopToolbar>
                <AppBar position="static">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="simple tabs example"
                    >
                        <Tab label="Informações" id="info" />
                        <Tab
                            label={`Histórico (${orderInfo?.OrderHistories?.length})`}
                            id="history"
                        />
                        <Tab
                            label={`Comentários (${orderInfo?.Comments?.length})`}
                            id="comments"
                        />
                        {permissions.includes('assistanceadmin') && (
                            <Tab
                                label={'Gate xml'}
                                id="gateXml"
                                onClick={() => getXmlGate(orderInfo?.id)}
                            />
                        )}
                        {permissions.includes('assistanceadmin') && (
                            <Tab
                                label={'Request Seguradora'}
                                id="insurerRequest"
                                onClick={() => getXmlGate(orderInfo?.id)}
                            />
                        )}
                        <Tab
                            label={'Emails'}
                            id="emails"
                            value={5}
                            onClick={() => getEmailLogs(orderInfo?.id)}
                        />
                    </Tabs>
                </AppBar>
                {/* Resumo */}
                <TabPanel value={value} index={0}>
                    {/* Alertas */}
                    <Paper>
                        {/* </TopToolbar> */}
                        {((Number(orderInfo?.status) === 7 &&
                            Number(orderInfo?.Payments[0].status) === 6) ||
                            (Number(orderInfo?.status) === 4 &&
                                Number(orderInfo?.Payments[0].status) === 3) ||
                            (Number(orderInfo?.status) === 8 &&
                                [2, 3, 6].includes(
                                    Number(orderInfo?.Payments[0].status)
                                ) &&
                                ['CreditCard', 'Invoice'].includes(
                                    orderInfo?.Payments[0].type
                                )) ||
                            (Number(orderInfo?.status) === 8 &&
                                [3].includes(
                                    Number(orderInfo?.Payments[0].status)
                                ) &&
                                orderInfo?.Payments[0].type !== 'CreditCard') ||
                            [12, 13].includes(Number(orderInfo?.status)) ||
                            ((Number(orderInfo?.status) === 1 ||
                                Number(orderInfo?.status) === 11) &&
                                (Number(orderInfo?.Payments[0].status) === 1 ||
                                    Number(orderInfo?.Payments[0].status) ===
                                        2) &&
                                (orderInfo?.Payments[0].type !== 'Transfer' ||
                                    orderInfo?.Payments[0].type !== 'Slip' ||
                                    (orderInfo?.Payments[0].type === 'Slip' &&
                                        (new Date(
                                            new Date().getTime() -
                                                3 * 60 * 60 * 1000
                                        ).getTime() -
                                            new Date(
                                                orderInfo?.Payments[0].createdAt
                                            ).getTime()) /
                                            (24 * 60 * 60 * 1000) <=
                                            2) ||
                                    (orderInfo?.Payments[0].type ===
                                        'Transfer' &&
                                        (new Date(
                                            new Date().getTime() -
                                                3 * 60 * 60 * 1000
                                        ).getTime() -
                                            new Date(
                                                orderInfo?.Payments[0].createdAt
                                            ).getTime()) /
                                            (24 * 60 * 60 * 1000) <=
                                            1)))) && (
                            <Grid container spacing={3}>
                                <Grid item sm={12} md={12}>
                                    Pendência:
                                    {Number(orderInfo?.status) === 7 &&
                                    Number(orderInfo?.Payments[0].status) === 6
                                        ? ' Apólice emitida, porém cartão de crédito não foi capturado. Forçar captura novamente!'
                                        : ''}
                                    {Number(orderInfo?.status) === 4 &&
                                    Number(orderInfo?.Payments[0].status) === 3
                                        ? ' Apólice emitida, porém Pedido não está como Concluído, verificar pendências e concluir.'
                                        : ''}
                                    {Number(orderInfo?.status) === 8 &&
                                    [2, 3, 6].includes(
                                        Number(orderInfo?.Payments[0].status)
                                    ) &&
                                    ['CreditCard', 'Invoice'].includes(
                                        orderInfo?.Payments[0].type
                                    )
                                        ? 'Erros na emissão e/ou captura do pagamento'
                                        : ''}
                                    {Number(orderInfo?.status) === 8 &&
                                    [3].includes(
                                        Number(orderInfo?.Payments[0].status)
                                    ) &&
                                    orderInfo?.Payments[0].type !== 'CreditCard'
                                        ? ' Erro na emissão da apólice, tentar novamente'
                                        : ''}
                                    {[12, 13].includes(
                                        Number(orderInfo?.status)
                                    )
                                        ? 'Realizar o estorno do pgto e/ou realizar cancelamento manual do voucher'
                                        : ''}
                                    {(Number(orderInfo?.status) === 1 ||
                                        Number(orderInfo?.status) === 11) &&
                                    (Number(orderInfo?.Payments[0].status) ===
                                        1 ||
                                        Number(
                                            orderInfo?.Payments[0].status
                                        ) === 2) &&
                                    (orderInfo?.Payments[0].type !==
                                        'Transfer' ||
                                        orderInfo?.Payments[0].type !==
                                            'Slip' ||
                                        (orderInfo?.Payments[0].type !==
                                            'Slip' &&
                                            (new Date(
                                                new Date().getTime() -
                                                    3 * 60 * 60 * 1000
                                            ).getTime() -
                                                new Date(
                                                    orderInfo?.Payments[0].createdAt
                                                ).getTime()) /
                                                (24 * 60 * 60 * 1000) <=
                                                2) ||
                                        (orderInfo?.Payments[0].type !==
                                            'Transfer' &&
                                            (new Date(
                                                new Date().getTime() -
                                                    3 * 60 * 60 * 1000
                                            ).getTime() -
                                                new Date(
                                                    orderInfo?.Payments[0].createdAt
                                                ).getTime()) /
                                                (24 * 60 * 60 * 1000) <=
                                                1))
                                        ? ' Verificar se pagamento foi capturado/confirmado nos gateways (webhook não recebido até o momento). Caso positivo, emitir manualmente'
                                        : ''}
                                </Grid>
                            </Grid>
                        )}
                    </Paper>
                    {/* Labels */}
                    <Paper>
                        <Grid container spacing={3}>
                            {orderInfo?.OrderLabels &&
                                orderInfo?.OrderLabels.map((item) => {
                                    return (
                                        <Grid item sm={2} md={2}>
                                            <Button
                                                InputProps={{ readOnly: true }}
                                                size="small"
                                                variant="outlined"
                                                style={{
                                                    width: 200,
                                                    borderRadius: 16,
                                                    backgroundColor:
                                                        item.Label
                                                            .backgroundColor,
                                                    font: item.Label.fontColor,
                                                }}
                                            >
                                                {item.Label.name}
                                            </Button>
                                            {permissions.includes(
                                                'assistanceadmin'
                                            ) && (
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="small"
                                                    style={{
                                                        width: 200,
                                                        backgroundColor: 'Red',
                                                    }}
                                                    onClick={() =>
                                                        removeTagModal(item.id)
                                                    }
                                                >
                                                    X
                                                </Button>
                                            )}
                                        </Grid>
                                    )
                                })}
                            {permissions.includes('assistanceadmin') && (
                                <Grid item sm={2} md={2}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        onClick={() =>
                                            handleNewTag(orderInfo?.OrderLabels)
                                        }
                                        style={{ backgroundColor: 'Green' }}
                                    >
                                        Adicionar Tag
                                    </Button>
                                </Grid>
                            )}
                        </Grid>
                    </Paper>
                    {/* Informações do Pedido */}
                    <Paper>
                        <h4>Informações do Pedido</h4>
                        <Grid container spacing={3}>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="id"
                                    label="Pedido"
                                    value={orderInfo?.id}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{
                                        readOnly: true,
                                        className:
                                            orderInfo?.status === 5
                                                ? classes.successInput
                                                : orderInfo?.status === 12 &&
                                                  orderInfo?.Payments[0]
                                                      .type === 'Invoice' &&
                                                  classes.warningInput
                                                ? orderInfo?.status === 12 &&
                                                  orderInfo?.Payments[0]
                                                      .type === 'Invoice' &&
                                                  classes.warningInput
                                                : [
                                                      6, 7, 8, 9, 10, 12, 13,
                                                      14,
                                                  ].includes(
                                                      orderInfo?.status
                                                  ) && classes.statusInput,
                                    }}
                                    id="statusText"
                                    label="Situação"
                                    value={orderInfo?.statusText}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="createdAt"
                                    label="createdAt"
                                    value={orderInfo?.createdAt}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="reservationId"
                                    label="Processo"
                                    value={orderInfo?.reservationId}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="fraudPreventionStatusText"
                                    label="Anti Fraude"
                                    value={orderInfo?.fraudPreventionStatusText}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="coupon"
                                    label="Cupom de Desconto"
                                    value={orderInfo?.coupon}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="extraRequests"
                                    label="Solicitação Adicional"
                                    value={orderInfo?.extraRequests}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="observation"
                                    label="Observações"
                                    value={orderInfo?.observation}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <h4>Preços</h4>
                        <Grid container spacing={3}>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="grossOrder"
                                    label="Valor Bruto"
                                    value={formatter.format(
                                        orderInfo?.gross || 0
                                    )}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="discountOrder"
                                    label="(-) Desconto"
                                    value={formatter.format(
                                        orderInfo?.discount || 0
                                    )}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="totalOrder"
                                    label="(=) Valor Final"
                                    value={formatter.format(
                                        orderInfo?.total || 0
                                    )}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="costOrder"
                                    label="(-) Custo"
                                    value={formatter.format(
                                        orderInfo?.cost || 0
                                    )}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="marginOrder"
                                    label="(=) Margem"
                                    value={formatter.format(
                                        orderInfo?.margin || 0
                                    )}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    {/* Produto */}
                    <Paper>
                        <h4>
                            Informações do Produto -{' '}
                            <a
                                target="_blank"
                                href={
                                    'https://dash.melhorseguro.com.br/#/admin/products/' +
                                    (orderInfo?.productId ||
                                        orderInfo?.planId) +
                                    '/show'
                                }
                                rel="noopener noreferrer"
                            >
                                Produto
                            </a>
                        </h4>
                        <Grid container spacing={3}>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="insurerName"
                                    label="Seguradora"
                                    value={
                                        orderInfo?.Insurer
                                            ? orderInfo?.Insurer.name
                                            : ''
                                    }
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="productName"
                                    label="productName"
                                    value={
                                        orderInfo?.productName
                                            ? orderInfo?.productName
                                            : ''
                                    }
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="productCode"
                                    label="productCode"
                                    value={
                                        orderInfo?.productCode
                                            ? orderInfo?.productCode
                                            : ''
                                    }
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item sm={12} md={2}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    InputLabelProps={{ shrink: true }}
                                    id="checkIn"
                                    label="Início"
                                    value={orderInfo?.checkIn}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={2}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    InputLabelProps={{ shrink: true }}
                                    id="checkOut"
                                    label="Fim"
                                    value={orderInfo?.checkOut}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={2}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    InputLabelProps={{ shrink: true }}
                                    id="checkOut"
                                    label="Diárias"
                                    value={orderInfo?.daily}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={2}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="destination"
                                    label="destination"
                                    value={
                                        orderInfo?.destination
                                            ? orderInfo?.destination
                                            : ''
                                    }
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="fareCode"
                                    label="fareCode"
                                    value={
                                        orderInfo?.fareCode
                                            ? orderInfo?.fareCode
                                            : ''
                                    }
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    {/* Origem */}
                    <Paper>
                        <h4>Origem do Pedido</h4>
                        <Grid container spacing={3}>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="originUrl"
                                    label="URL Origem"
                                    value={orderInfo?.originUrl}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="previousUrl"
                                    label="URL Final"
                                    value={orderInfo?.previousUrl}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="sessionId"
                                    label="sessionId"
                                    value={orderInfo?.sessionId}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={6}>
                            <Grid item sm={12} md={2}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="source"
                                    label="source"
                                    value={orderInfo?.source}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={2}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="affiliateId"
                                    label="affiliateId"
                                    value={orderInfo?.affiliateId}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={2}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="utmMedium"
                                    label="utmMedium"
                                    value={orderInfo?.utmMedium}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={2}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="identifier"
                                    label="identifier"
                                    value={orderInfo?.identifier}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={2}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="utmContent"
                                    label="utmContent"
                                    value={orderInfo?.utmContent}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item sm={12} md={2}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="utmTerm"
                                    label="utmTerm"
                                    value={orderInfo?.utmTerm}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    {/* Pagamentos */}
                    <Paper>
                        <h4>
                            Pagamentos
                            {![5, 9, 12, 13, 14].includes(orderInfo?.status) &&
                                permissions.includes('assistanceadmin') && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        onClick={() =>
                                            setPaymentModalOpen(true)
                                        }
                                        style={{
                                            backgroundColor: 'Green',
                                            marginLeft: 15,
                                        }}
                                    >
                                        Adicionar Pagamento
                                    </Button>
                                )}
                        </h4>
                        {orderInfo?.Payments &&
                            orderInfo?.Payments.map((payment, index) => {
                                switch (payment.type) {
                                    case 'CreditCard':
                                        return (
                                            <Paper>
                                                <h4>Cartão {index + 1}</h4>
                                                <Grid container spacing={3}>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="cardHolder"
                                                            label="Pagador"
                                                            value={
                                                                payment.cardHolder
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={4}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="cardNumber"
                                                            label="Cartão"
                                                            value={
                                                                payment.cardNumber
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="statusText"
                                                            label="Situação"
                                                            value={
                                                                payment.statusText
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            style={{
                                                                backgroundColor:
                                                                    changeBackgroundByPaymentStatus(
                                                                        payment.statusText
                                                                    ),
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: false,
                                                            }}
                                                            id="createdAt"
                                                            label="createdAt"
                                                            value={
                                                                payment.createdAt
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={2}>
                                                        {[6, 8, 11].includes(
                                                            orderInfo?.status
                                                        ) &&
                                                            permissions.includes(
                                                                'assistanceadmin'
                                                            ) && (
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    style={{
                                                                        backgroundColor:
                                                                            'Green',
                                                                    }}
                                                                    onClick={() =>
                                                                        forceBookingModal(
                                                                            payment.id
                                                                        )
                                                                    }
                                                                >
                                                                    {[
                                                                        6, 11,
                                                                    ].includes(
                                                                        orderInfo?.status
                                                                    ) &&
                                                                        'Aprovar Manualmente'}
                                                                </Button>
                                                            )}
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={3}>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="cardBrand"
                                                            label="Bandeira"
                                                            value={
                                                                payment.cardBrand
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="cardValue"
                                                            label="Valor"
                                                            value={formatter.format(
                                                                payment.value
                                                            )}
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    {payment.status == 10 && (
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={2}
                                                        >
                                                            <TextField
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                                id="refundValue"
                                                                label="Valor Estornado"
                                                                value={calculateRefund(
                                                                    payment.value
                                                                )}
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                    )}
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="installments"
                                                            label="Parcelas"
                                                            value={`${payment.installments}x`}
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="paymentId"
                                                            label="ID Pagamento Cielo"
                                                            value={
                                                                payment.cardPaymentId
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="cardAuthorization"
                                                            label="Autorização"
                                                            value={
                                                                payment.cardAuthorization
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        )
                                    case 'Invoice':
                                        return (
                                            <Paper>
                                                <h4>Faturado</h4>
                                                <Grid container spacing={3}>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="cardValue"
                                                            label="Valor"
                                                            value={formatter.format(
                                                                payment.value
                                                            )}
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={7}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="slipStatus"
                                                            label="Situação"
                                                            value={
                                                                payment.statusText
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            style={{
                                                                backgroundColor:
                                                                    changeBackgroundByPaymentStatus(
                                                                        payment.statusText
                                                                    ),
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={3}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: false,
                                                            }}
                                                            id="createdAt"
                                                            label="createdAt"
                                                            value={
                                                                payment.createdAt
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        )
                                    case 'Transfer':
                                        return (
                                            <Paper>
                                                <h4>
                                                    Transferência/Pix -{' '}
                                                    <a
                                                        target="_blank"
                                                        href={
                                                            'https://www2.paymee.com.br/merchants/Transaction/' +
                                                            payment.transferUuid
                                                        }
                                                        rel="noopener noreferrer"
                                                    >
                                                        PayMee
                                                    </a>
                                                </h4>
                                                <Grid container spacing={3}>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="cardValue"
                                                            label="Valor"
                                                            value={formatter.format(
                                                                payment.value
                                                            )}
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    {payment.status == 10 && (
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={2}
                                                        >
                                                            <TextField
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                                id="refundValue"
                                                                label="Valor Estornado"
                                                                value={calculateRefund(
                                                                    payment.value
                                                                )}
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                    )}
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="transferMethod"
                                                            label="Método"
                                                            value={
                                                                payment.transferMethod
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="slipStatus"
                                                            label="Situação"
                                                            value={
                                                                payment.statusText
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            style={{
                                                                backgroundColor:
                                                                    changeBackgroundByPaymentStatus(
                                                                        payment.statusText
                                                                    ),
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: false,
                                                            }}
                                                            id="createdAt"
                                                            label="createdAt"
                                                            value={
                                                                payment.createdAt
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={2}>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            style={{
                                                                backgroundColor:
                                                                    'Green',
                                                            }}
                                                            onClick={() =>
                                                                forceResendEmailModal(
                                                                    orderInfo?.id
                                                                )
                                                            }
                                                        >
                                                            Reenviar email de
                                                            pagamento
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        )
                                    case 'Slip':
                                        return (
                                            <Paper>
                                                <h4>Boleto</h4>
                                                <Grid container spacing={3}>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="cardValue"
                                                            label="Valor"
                                                            value={formatter.format(
                                                                payment.value
                                                            )}
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={3}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="slipStatus"
                                                            label="Situação"
                                                            value={
                                                                payment.statusText
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            style={{
                                                                backgroundColor:
                                                                    changeBackgroundByPaymentStatus(
                                                                        payment.statusText
                                                                    ),
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={4}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: false,
                                                            }}
                                                            id="slipUrl"
                                                            label="URL Boleto"
                                                            value={
                                                                payment.slipUrl
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={3}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: false,
                                                            }}
                                                            id="createdAt"
                                                            label="createdAt"
                                                            value={
                                                                payment.createdAt
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={2}>
                                                        {[6, 8, 11].includes(
                                                            orderInfo?.status
                                                        ) &&
                                                            permissions.includes(
                                                                'assistanceadmin'
                                                            ) && (
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    style={{
                                                                        backgroundColor:
                                                                            'Green',
                                                                    }}
                                                                    onClick={() =>
                                                                        forceBookingModal(
                                                                            payment.id
                                                                        )
                                                                    }
                                                                >
                                                                    {[
                                                                        6, 11,
                                                                    ].includes(
                                                                        orderInfo?.status
                                                                    ) &&
                                                                        'Aprovar Manualmente'}
                                                                </Button>
                                                            )}
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        )
                                    case 'Link':
                                        return (
                                            <Paper>
                                                <h4>
                                                    {getPagturTypePayment(
                                                        record.fop
                                                    )}{' '}
                                                    -{' '}
                                                    <a
                                                        target="_blank"
                                                        href={payment.linkUrl}
                                                        rel="noopener noreferrer"
                                                    >
                                                        Pagtur
                                                    </a>
                                                </h4>
                                                <Grid container spacing={3}>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="cardValue"
                                                            label="Valor"
                                                            value={formatter.format(
                                                                payment.value
                                                            )}
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    {payment.status == 10 && (
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={2}
                                                        >
                                                            <TextField
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                                id="refundValue"
                                                                label="Valor Estornado"
                                                                value={calculateRefund(
                                                                    payment.value
                                                                )}
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                    )}
                                                    <Grid item sm={12} md={3}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="slipStatus"
                                                            label="Situação"
                                                            value={
                                                                payment.statusText
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            style={{
                                                                backgroundColor:
                                                                    changeBackgroundByPaymentStatus(
                                                                        payment.statusText
                                                                    ),
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={3}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: false,
                                                            }}
                                                            id="linkUrl"
                                                            label="URL do Link"
                                                            value={
                                                                payment.linkUrl
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: false,
                                                            }}
                                                            id="createdAt"
                                                            label="createdAt"
                                                            value={
                                                                payment.createdAt
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={2}>
                                                        {[6, 8, 11].includes(
                                                            orderInfo?.status
                                                        ) &&
                                                            permissions.includes(
                                                                'assistanceadmin'
                                                            ) && (
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    style={{
                                                                        backgroundColor:
                                                                            'Green',
                                                                    }}
                                                                    onClick={() =>
                                                                        forceBookingModal(
                                                                            payment.id
                                                                        )
                                                                    }
                                                                >
                                                                    {[
                                                                        6, 11,
                                                                    ].includes(
                                                                        orderInfo?.status
                                                                    ) &&
                                                                        'Aprovar Manualmente'}
                                                                </Button>
                                                            )}
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        )
                                    case 'Manual':
                                        return (
                                            <Paper>
                                                <h4>Pagamento Manual</h4>
                                                <Grid container spacing={3}>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="cardValue"
                                                            label="Valor"
                                                            value={formatter.format(
                                                                payment.value
                                                            )}
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={3}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="slipStatus"
                                                            label="Situação"
                                                            value={
                                                                payment.statusText
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            style={{
                                                                backgroundColor:
                                                                    changeBackgroundByPaymentStatus(
                                                                        payment.statusText
                                                                    ),
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={3}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: false,
                                                            }}
                                                            id="createdAt"
                                                            label="createdAt"
                                                            value={
                                                                payment.createdAt
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={3}>
                                                        <TextField
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <ContentCopyIcon
                                                                        onClick={() =>
                                                                            navigator.clipboard.writeText(
                                                                                payment.attachment
                                                                            )
                                                                        }
                                                                        cursor={
                                                                            'pointer'
                                                                        }
                                                                    />
                                                                ),
                                                                readOnly: true,
                                                            }}
                                                            label="Url comprovante"
                                                            value={
                                                                payment.attachment
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        )
                                    default:
                                        return null
                                }
                            })}
                    </Paper>
                    {/* Usuário */}
                    {orderInfo?.userId && orderInfo?.userId > 0 && (
                        <Paper>
                            <h4>
                                Usuário -{' '}
                                <a
                                    target="_blank"
                                    href={
                                        'https://dash.melhorseguro.com.br/#/admin/users/' +
                                        orderInfo?.userId
                                    }
                                    rel="noopener noreferrer"
                                >
                                    Perfil
                                </a>
                            </h4>
                            <Grid container spacing={3}>
                                <Grid item sm={12} md={4}>
                                    <TextField
                                        InputProps={{ readOnly: true }}
                                        id="userId"
                                        label="userId"
                                        value={orderInfo?.userId}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item sm={12} md={4}>
                                    <TextField
                                        InputProps={{ readOnly: true }}
                                        id="email"
                                        label="users.email"
                                        value={orderInfo?.Users.email}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item sm={12} md={4}>
                                    <TextField
                                        InputProps={{ readOnly: true }}
                                        id="gateId"
                                        label="gateId"
                                        value={orderInfo?.gateId}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    )}
                    <Paper>
                        <h4>Agente Emissor</h4>
                        <Grid container spacing={3}>
                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="travelAgent"
                                    label="Agente"
                                    value={
                                        orderInfo?.TravelAgent
                                            ? orderInfo?.TravelAgent.email
                                            : ''
                                    }
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>

                            <Grid item sm={12} md={4}>
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    id="corporateName"
                                    label="Empresa"
                                    value={
                                        orderInfo?.TravelAgent
                                            ? orderInfo?.TravelAgent
                                                  .corporateName
                                            : ''
                                    }
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>

                            {!orderInfo?.TravelAgent?.email && (
                                <Grid item sm={2} md={2}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        onClick={() =>
                                            setOpenNewAgentDialog(true)
                                        }
                                        style={{ backgroundColor: 'Green' }}
                                    >
                                        Adicionar Agente
                                    </Button>
                                </Grid>
                            )}
                        </Grid>
                    </Paper>
                    {/* Responsável */}
                    <Paper>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                height: '60px',
                            }}
                        >
                            <h4>Responsável / Pagador</h4>
                            {(orderInfo?.status === 11 ||
                                orderInfo?.status === 8) &&
                                permissions.includes('assistanceadmin') && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ backgroundColor: 'Blue' }}
                                        onClick={() =>
                                            setUpdateOwnerDateModal(true)
                                        }
                                    >
                                        Editar Dados
                                    </Button>
                                )}
                        </div>
                        {orderInfo && orderInfo?.ownerName ? (
                            <Paper>
                                <Grid container spacing={3}>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            id="ownerName"
                                            label="Nome"
                                            value={orderInfo?.ownerName}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            id="ownerDob"
                                            label="Data Nascimento"
                                            value={formatDate(
                                                orderInfo?.ownerDob
                                            )}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            id="ownerPhone"
                                            label="Telefone"
                                            value={orderInfo?.ownerPhone}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            id="ownerEmail"
                                            label="Email"
                                            value={orderInfo?.ownerEmail}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid item sm={12} md={4}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            id="ownerAddress"
                                            label="Endereço"
                                            value={orderInfo?.ownerAddress}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={4}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            id="ownerNumber"
                                            label="Número"
                                            value={orderInfo?.ownerNumber}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={4}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            id="ownerComplement"
                                            label="Complemento"
                                            value={orderInfo?.ownerComplement}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid item sm={12} md={4}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            id="ownerDistrict"
                                            label="Bairro"
                                            value={orderInfo?.ownerDistrict}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={4}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            id="ownerCity"
                                            label="Cidade"
                                            value={orderInfo?.ownerCity}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={2}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            id="ownerState"
                                            label="Estado"
                                            value={orderInfo?.ownerState}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={2}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            id="ownerCep"
                                            label="Cep"
                                            value={orderInfo?.ownerCep}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                        ) : (
                            <>
                                <p>Carregando...</p>
                            </>
                        )}
                        <h4>Contato Emergência</h4>
                        <Paper>
                            <Grid container spacing={3}>
                                <Grid item sm={12} md={4}>
                                    <TextField
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        id="emergencyName"
                                        label="emergencyName"
                                        value={orderInfo?.emergencyName}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item sm={12} md={4}>
                                    <TextField
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        id="emergencyPhone"
                                        label="emergencyPhone"
                                        value={orderInfo?.emergencyPhone}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item sm={12} md={4}>
                                    <TextField
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        id="emergencyCellphone"
                                        label="emergencyCellphone"
                                        value={orderInfo?.emergencyCellphone}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Paper>
                    {/* Pessoa Juridica (empresa) */}
                    {orderInfo?.isCompany && (
                        <Paper>
                            <h4>Empresa</h4>
                            <Paper>
                                <Grid container spacing={3}>
                                    <Grid item sm={12} md={4}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            id="companyName"
                                            label="Nome"
                                            value={orderInfo?.companyName}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={4}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            id="gateId"
                                            label="gateId"
                                            value={orderInfo?.gateId}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={4}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            id="observation"
                                            label="Observações"
                                            value={orderInfo?.observation}
                                            variant="outlined"
                                            size="small"
                                            multiline
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Paper>
                    )}
                    {/* Segurados */}
                    <Paper>
                        <h4>Segurados / Vouchers</h4>
                        {orderInfo && orderInfo?.ownerName ? (
                            <>
                                {orderInfo &&
                                    orderInfo?.status === 5 &&
                                    permissions.includes('assistanceadmin') && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{
                                                backgroundColor: 'yellowgreen',
                                                marginRight: '20px',
                                            }}
                                            onClick={() =>
                                                handleMainlyCancelVoucherModal(
                                                    orderInfo?.id
                                                )
                                            }
                                        >
                                            Editar Vouchers
                                        </Button>
                                    )}
                                {/* Cancelar Vouchers */}
                                {orderInfo?.Passengers &&
                                    orderInfo?.Passengers.length &&
                                    (permissions.includes('assistanceadmin') ||
                                        permissions.includes('apimanager')) &&
                                    [4, 5, 8].includes(
                                        orderInfo?.status
                                    ) && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{ backgroundColor: 'Red' }}
                                            onClick={() =>
                                                cancelOrderModal(orderInfo?.id)
                                            }
                                        >
                                            Cancelar Todos Vouchers + Estorno
                                            Integral
                                        </Button>
                                    )}
                                {orderInfo?.Passengers &&
                                    orderInfo?.Passengers.length &&
                                    permissions.includes('assistanceadmin') &&
                                    [4, 5, 8].includes(orderInfo?.status) &&
                                    orderInfo?.Payments[0].type !==
                                        'Invoice' && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{
                                                backgroundColor: 'Tomato',
                                                marginLeft: '20px',
                                            }}
                                            onClick={() =>
                                                cancelPartialOrderModal(
                                                    orderInfo?.id
                                                )
                                            }
                                        >
                                            Cancelar Todos Vouchers + Estorno
                                            Parcial
                                        </Button>
                                    )}

                                {!record?.TravelAgent?.Enterprise &&
                                    orderInfo?.Passengers &&
                                    orderInfo?.Passengers.length &&
                                    [8].includes(orderInfo?.status) &&
                                    orderInfo?.Insurer.id !== 6 && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{
                                                backgroundColor: 'green',
                                                marginLeft: '20px',
                                            }}
                                            onClick={() =>
                                                setIssuedManuallyFirstStep(true)
                                            }
                                        >
                                            Emitir Manualmente
                                        </Button>
                                    )}

                                {record?.TravelAgent?.Enterprise
                                    .allowManualIssuance &&
                                    orderInfo?.Passengers &&
                                    orderInfo?.Passengers.length &&
                                    [8].includes(orderInfo?.status) &&
                                    orderInfo?.Insurer.id !== 6 && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{
                                                backgroundColor: 'green',
                                                marginLeft: '20px',
                                            }}
                                            onClick={() =>
                                                setIssuedManuallyFirstStep(true)
                                            }
                                        >
                                            Emitir Manualmente
                                        </Button>
                                    )}
                                {orderInfo?.Passengers &&
                                    orderInfo?.Passengers.map(
                                        (pax, paxIndex) => (
                                            <Paper key={paxIndex}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'baseline',
                                                    }}
                                                >
                                                    <h4
                                                        style={{
                                                            margin: '0px 10px 0px 0px',
                                                        }}
                                                    >
                                                        Segurado {paxIndex + 1}
                                                    </h4>
                                                </div>
                                                <Grid container spacing={3}>
                                                    <Grid item sm={12} md={4}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="owner"
                                                            label="Responsável"
                                                            value={pax.name}
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={4}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            id="paxCpf"
                                                            label="Cpf"
                                                            value={pax.cpf}
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={4}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            id="paxDob"
                                                            label="Nascimento"
                                                            value={formatDate(
                                                                pax.dob
                                                            )}
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={5}>
                                                    <Grid item sm={12} md={3}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly:
                                                                    !canEditHeroVoucher,
                                                            }}
                                                            id="voucher"
                                                            label="Voucher"
                                                            value={
                                                                heroVoucherEdits[
                                                                    pax.id
                                                                ]?.voucher ??
                                                                pax.voucher
                                                            }
                                                            onChange={(e) =>
                                                                handleHeroVoucherChange(
                                                                    pax.id,
                                                                    'voucher',
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={3}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="voucherStatus"
                                                            label="voucherStatus"
                                                            value={
                                                                pax.voucherStatus
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <ContentCopyIcon
                                                                        onClick={() =>
                                                                            navigator.clipboard.writeText(
                                                                                pax.voucherUrl
                                                                            )
                                                                        }
                                                                        cursor={
                                                                            'pointer'
                                                                        }
                                                                    />
                                                                ),
                                                                readOnly:
                                                                    !canEditHeroVoucher,
                                                            }}
                                                            id="voucherUrlPt"
                                                            label="VoucherUrlPt"
                                                            value={
                                                                heroVoucherEdits[
                                                                    pax.id
                                                                ]?.voucherUrl ??
                                                                pax.voucherUrl
                                                            }
                                                            onChange={(e) =>
                                                                handleHeroVoucherChange(
                                                                    pax.id,
                                                                    'voucherUrl',
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <ContentCopyIcon
                                                                        onClick={() =>
                                                                            navigator.clipboard.writeText(
                                                                                pax.voucherUrlEn
                                                                            )
                                                                        }
                                                                        cursor={
                                                                            'pointer'
                                                                        }
                                                                    />
                                                                ),
                                                                readOnly:
                                                                    !canEditHeroVoucher,
                                                            }}
                                                            id="voucherUrlEn"
                                                            label="VoucherUrlEn"
                                                            value={
                                                                heroVoucherEdits[
                                                                    pax.id
                                                                ]
                                                                    ?.voucherUrlEn ??
                                                                pax.voucherUrlEn
                                                            }
                                                            onChange={(e) =>
                                                                handleHeroVoucherChange(
                                                                    pax.id,
                                                                    'voucherUrlEn',
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    {canEditHeroVoucher && (
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={2}
                                                        >
                                                            <Button
                                                                size="small"
                                                                variant="contained"
                                                                color="primary"
                                                                style={{
                                                                    marginTop:
                                                                        '4px',
                                                                }}
                                                                onClick={() =>
                                                                    handleSaveHeroVoucher(
                                                                        pax
                                                                    )
                                                                }
                                                            >
                                                                Salvar
                                                            </Button>
                                                        </Grid>
                                                    )}
                                                    {pax.voucherUpgradeUrl >
                                                        0 && (
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={2}
                                                        >
                                                            <form
                                                                action={
                                                                    pax.voucherUpgradeUrl
                                                                }
                                                            >
                                                                <Button
                                                                    size="small"
                                                                    variant="contained"
                                                                    type="submit"
                                                                    color="primary"
                                                                    style={{
                                                                        marginTop:
                                                                            '4px',
                                                                    }}
                                                                >
                                                                    Abrir
                                                                    Voucher
                                                                </Button>
                                                            </form>
                                                        </Grid>
                                                    )}
                                                    <Grid item sm={12} md={2}>
                                                        <TextField
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            id="markup"
                                                            label="Markup R$"
                                                            value={pax.markup}
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        )
                                    )}
                            </>
                        ) : (
                            <>
                                <p>Carregando...</p>
                            </>
                        )}
                    </Paper>
                    {/* Remover Pedidos */}
                    {[1, 2, 8, 9, 10, 11].includes(orderInfo?.status) &&
                        permissions.includes('sysadmin') && (
                            <Paper>
                                <h4>
                                    ATENÇÃO: Botão para remover pedidos de TESTE
                                </h4>
                                <p style={{ color: 'red' }}>
                                    Realizar e confirmar o cancelamento de
                                    voucher e estorno de pagamento antes de
                                    remover o pedido. Caso contrário,
                                    permanecerá uma venda ativa com status
                                    incorretos.
                                </p>
                                <p>
                                    Ao remover um pedido todos os pagamentos,
                                    vouchers e pedido mudarão para status
                                    "Removido"
                                </p>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    style={{
                                        backgroundColor: 'Grey',
                                        textAlign: 'center',
                                    }}
                                    onClick={() =>
                                        removeOrderModal(orderInfo?.id)
                                    }
                                >
                                    Remover Pedido
                                </Button>
                            </Paper>
                        )}
                </TabPanel>
                {/* Histórico do Pedido */}
                <TabPanel value={value} index={1}>
                    <Paper>
                        <h4>Histórico do Pedido</h4>
                        {orderInfo?.OrderHistories &&
                            orderInfo?.OrderHistories.map((history, index) => (
                                <Grid key={index} container spacing={3}>
                                    <Grid item sm={12} md={6}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="action"
                                            label="Ação"
                                            value={history.action}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={2}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="user"
                                            label="Usuário"
                                            value={history.user}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={2}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="actionDate"
                                            label="Data"
                                            value={formatDateTime(
                                                history.createdAt
                                            )}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={2}>
                                        <TextField
                                            id="attachment"
                                            label="Anexo"
                                            value={history.attachment}
                                            InputProps={{
                                                endAdornment: (
                                                    <ContentCopyIcon
                                                        onClick={() =>
                                                            navigator.clipboard.writeText(
                                                                history.attachment
                                                            )
                                                        }
                                                        cursor={'pointer'}
                                                    />
                                                ),
                                                readOnly: true,
                                            }}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            ))}
                    </Paper>
                </TabPanel>
                <TopToolbar
                    className={classes.actions}
                    style={{ justifyContent: 'flex-end' }}
                >
                    {/* Reenvio Gate: apenas se Concluído / Se a permissão do usuário for de sysadmin */}
                    {[5].includes(orderInfo?.status) &&
                        permissions.includes('sysadmin') && (
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ backgroundColor: 'Red' }}
                                onClick={() => sendGateModal()}
                            >
                                REPROCESSAR PEDIDO NO GATE
                            </Button>
                        )}
                </TopToolbar>
                {/* Comentarios */}
                <TabPanel value={value} index={2}>
                    <Paper>
                        <Grid container spacing={3}>
                            <Grid item sm={12} md={12}>
                                <h4>
                                    Comentários
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        onClick={() =>
                                            setCommentModalOpen(true)
                                        }
                                        style={{
                                            backgroundColor: 'Green',
                                            marginLeft: 15,
                                        }}
                                    >
                                        Adicionar Comentário
                                    </Button>
                                </h4>
                            </Grid>
                        </Grid>
                        {orderInfo?.Comments &&
                            orderInfo?.Comments.map((comment, index) => (
                                <Grid key={index} container spacing={3}>
                                    <Grid item sm={12} md={8}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="comment"
                                            label="Comentário"
                                            value={comment.comment}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={2}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="user"
                                            label="Usuário"
                                            value={comment.user}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={2}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="actionDate"
                                            label="Data"
                                            value={formatDateTime(
                                                comment.createdAt
                                            )}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            ))}
                    </Paper>
                </TabPanel>
                {/* Gate xml */}
                <TabPanel value={value} index={3}>
                    <Paper>
                        <Grid container spacing={3}>
                            <Grid item sm={3} md={3}>
                                <div>{gateXml}</div>
                            </Grid>
                        </Grid>
                    </Paper>
                </TabPanel>

                <TabPanel value={value} index={4}>
                    <Paper>
                        <Grid container spacing={3}>
                            <Grid item sm={3} md={3}>
                                <div>{orderInfo?.insurerRequest}</div>
                            </Grid>
                        </Grid>
                    </Paper>
                </TabPanel>
                {/* Emails */}
                <TabPanel value={value} index={5}>
                    <Paper>
                        <h4>Histórico de E-mails</h4>
                        {emailLogs.length === 0 && (
                            <span>
                                Nenhum e-mail encontrado para este pedido.
                            </span>
                        )}
                        {emailLogs.map((emailLog, index) => {
                            const lastStatus =
                                emailLog.status?.[emailLog.status.length - 1]
                            const lastStatusLabel = lastStatus
                                ? emailEventLabels[lastStatus.event] ||
                                  lastStatus.event
                                : '-'
                            const bounceStatus = emailLog.status?.find(
                                (status) => status.event === 'bounce'
                            )
                            return (
                                <Grid key={index} container spacing={3}>
                                    <Grid item sm={12} md={4}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            label="Assunto"
                                            value={emailLog.subject || ''}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            label="Destinatário"
                                            value={emailLog.to || ''}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={2}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            label="Enviado em"
                                            value={formatDateTime(
                                                emailLog.sentAt
                                            )}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={2}>
                                        <Tooltip
                                            title={
                                                <>
                                                    {emailLog.status?.map(
                                                        (status, i) => (
                                                            <div key={i}>
                                                                {formatDateTime(
                                                                    status.time
                                                                )}
                                                                {' - '}
                                                                {emailEventLabels[
                                                                    status.event
                                                                ] ||
                                                                    status.event}
                                                            </div>
                                                        )
                                                    )}
                                                </>
                                            }
                                        >
                                            <TextField
                                                InputProps={{
                                                    readOnly: true,
                                                    style: {
                                                        color: emailEventColors[
                                                            lastStatus?.event
                                                        ],
                                                    },
                                                }}
                                                label="Status"
                                                value={lastStatusLabel}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                            />
                                        </Tooltip>
                                    </Grid>
                                    <Grid item sm={12} md={1}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            disabled={!emailLog.html}
                                            onClick={() =>
                                                setEmailPreview(emailLog)
                                            }
                                        >
                                            Ver
                                        </Button>
                                    </Grid>
                                    {bounceStatus && (
                                        <Grid item sm={12} md={12}>
                                            <TextField
                                                InputProps={{
                                                    readOnly: true,
                                                    style: { color: 'red' },
                                                }}
                                                label="Motivo"
                                                value={
                                                    bounceStatus.reason ||
                                                    bounceStatus.rawPayload
                                                        ?.reason ||
                                                    '-'
                                                }
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                multiline
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            )
                        })}
                    </Paper>
                </TabPanel>
                <Dialog // visualizar e-mail
                    open={!!emailPreview}
                    onClose={() => setEmailPreview(null)}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle>{emailPreview?.subject}</DialogTitle>
                    <DialogContent>
                        <iframe
                            title="email-preview"
                            srcDoc={emailPreview?.html}
                            sandbox=""
                            style={{
                                width: '100%',
                                height: '70vh',
                                border: 'none',
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setEmailPreview(null)}
                            color="primary"
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog // aprovar manualmente
                    open={forceBookingModalOpen}
                    onClose={() => setforceBookingModalOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Tem certeza que deseja efetuar a reserva
                            manualmente? Esta ação irá mudar manualmente o
                            status do pagamento para Capturado e realizará a
                            emissão de todos os vouchers
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                approveManually(orderInfo?.id, paymentId)
                                setforceBookingModalOpen(false)
                            }}
                            color="primary"
                        >
                            Sim
                        </Button>
                        <Button
                            onClick={() => setforceBookingModalOpen(false)}
                            color="primary"
                            autoFocus
                        >
                            Não
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog // cancelar manualmente integral
                    open={forceCancelModalOpen}
                    onClose={() => setforceCancelModalOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Tem certeza que deseja cancelar a reserva
                            manualmente? Esta ação irá mudar manualmente o
                            status do pagamento para Cancelado e realizará o
                            cancelamento de todos os vouchers
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                cancelManually(orderInfo?.id)
                                setforceCancelModalOpen(false)
                            }}
                            color="primary"
                        >
                            Sim
                        </Button>
                        <Button
                            onClick={() => setforceCancelModalOpen(false)}
                            color="primary"
                            autoFocus
                        >
                            Não
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog // cancelar manualmente parcial
                    open={forceCancelPartialModalOpen}
                    onClose={() => setforceCancelPartialModalOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Tem certeza que deseja cancelar a reserva
                            manualmente de forma parcial? Esta ação irá mudar
                            manualmente o status do pagamento para Cancelado e
                            realizará o cancelamento de todos os vouchers
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                cancelPartialManually(orderInfo?.id)
                                setforceCancelPartialModalOpen(false)
                            }}
                            color="primary"
                        >
                            Sim
                        </Button>
                        <Button
                            onClick={() =>
                                setforceCancelPartialModalOpen(false)
                            }
                            color="primary"
                            autoFocus
                        >
                            Não
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog // cancelar voucher
                    open={cancelVoucherModalOpen}
                    onClose={() => setCancelVoucherModalOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Tem certeza que deseja cancelar este voucher? Esta
                            ação vai cancelar o voucher individualmente
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                cancelVoucher()
                                setCancelVoucherModalOpen(false)
                            }}
                            color="primary"
                        >
                            Sim
                        </Button>
                        <Button
                            onClick={() => setCancelVoucherModalOpen(false)}
                            color="primary"
                            autoFocus
                        >
                            Não
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog // cancelar pedido
                    open={cancelOrderModalOpen}
                    onClose={() => setCancelOrderModalOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Tem certeza que deseja cancelar o pedido? Esta ação
                            irá cancelar todos os vouchers e o pedido
                            {orderInfo?.OrderHistories?.find(
                                (historie) =>
                                    historie.action ===
                                    'Apólices anexadas manualmente'
                            ) && (
                                <p style={{ color: 'red' }}>
                                    {' '}
                                    Como a emissão dos vouchers foi realizada
                                    manualmente, é necessário acessar o portal
                                    da seguradora para efetuar o cancelamento
                                    manualmente.
                                </p>
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                cancelOrder()
                                setCancelOrderModalOpen(false)
                            }}
                            color="primary"
                        >
                            Sim
                        </Button>
                        <Button
                            onClick={() => setCancelOrderModalOpen(false)}
                            color="primary"
                            autoFocus
                        >
                            Não
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog // cancelar pedido parcialmente
                    open={cancelPartialOrderModalOpen}
                    onClose={() => setCancelPartialOrderModalOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Tem certeza que deseja cancelar o pedido
                            parcialmente(80%)? Esta ação irá cancelar todos os
                            vouchers e o pedido
                            {orderInfo?.OrderHistories?.find(
                                (historie) =>
                                    historie.action ===
                                    'Apólices anexadas manualmente'
                            ) && (
                                <p style={{ color: 'red' }}>
                                    {' '}
                                    Como a emissão dos vouchers foi realizada
                                    manualmente, é necessário acessar o portal
                                    da seguradora para efetuar o cancelamento
                                    manualmente.
                                </p>
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                cancelPartialOrder()
                                setCancelPartialOrderModalOpen(false)
                            }}
                            color="primary"
                        >
                            Sim
                        </Button>
                        <Button
                            onClick={() =>
                                setCancelPartialOrderModalOpen(false)
                            }
                            color="primary"
                            autoFocus
                        >
                            Não
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog // remover pedido
                    open={removeOrderModalOpen}
                    onClose={() => setRemoveOrderModalOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Tem certeza que deseja remover o pedido??? ATENÇÃO!!
                            Realizar e confirmar o cancelamento de voucher e
                            estorno de pagamento antes de remover o pedido. Caso
                            contrário, permanecerá uma venda ativa e status
                            incorreto.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                removeOrder()
                                setRemoveOrderModalOpen(false)
                            }}
                            color="primary"
                        >
                            Sim
                        </Button>
                        <Button
                            onClick={() => setRemoveOrderModalOpen(false)}
                            color="primary"
                            autoFocus
                        >
                            Não
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog // reenviar voucher
                    open={sendVoucherModalOpen}
                    onClose={() => setSendVoucherModalOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Deseja reenviar o voucher?
                        </DialogContentText>
                        <TextField
                            id="emailVoucher"
                            label="E-Mail"
                            value={emailVoucher}
                            onChange={(e) => setEmailVoucher(e.target.value)}
                            variant="outlined"
                            size="small"
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                sendVoucher(orderInfo?.id, emailVoucher)
                                setSendVoucherModalOpen(false)
                            }}
                            color="primary"
                        >
                            Enviar
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog // adicionar comentário
                    open={commentModalOpen}
                    onClose={() => setCommentModalOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Adicionar comentário
                        </DialogContentText>
                        <TextField
                            id="comment"
                            label="Comentário"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            variant="outlined"
                            size="medium"
                            style={{
                                minWidth: 400,
                                height: 400,
                                minHeight: 400,
                            }}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                addComment(orderInfo?.id, comment)
                                setCommentModalOpen(false)
                            }}
                            color="primary"
                        >
                            Enviar
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog // adicionar pagamento
                    open={paymentModalOpen}
                    onClose={() => setPaymentModalOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{ minwidth: 400 }}
                >
                    <DialogContent style={{ minwidth: 400 }}>
                        <DialogContentText id="alert-dialog-description">
                            Adicionar pagamento
                        </DialogContentText>
                        <p>
                            <strong>Valor:</strong>
                        </p>
                        <p>{formatter.format(orderInfo?.total || 0)}</p>
                        <p>
                            <strong>Forma de Pgto:</strong>
                        </p>
                        <p>
                            <Select
                                labelId="type"
                                id="type"
                                value={newPayment}
                                onChange={(e) =>
                                    handleChangeNewPayment(e.target.value)
                                }
                                label="Forma de Pagamento"
                            >
                                <MenuItem value={'Manual'}>
                                    Pagamento Manual
                                </MenuItem>
                                <MenuItem value={'Invoice'}>Faturado</MenuItem>
                                <MenuItem value={'Transfer'}>
                                    Pix via Link Paymee
                                </MenuItem>
                                <MenuItem value={'Link'}>
                                    Cartão via Link Pagtur
                                </MenuItem>
                            </Select>
                        </p>

                        <p>
                            {['Manual'].includes(newPayment) && (
                                <>
                                    <input
                                        type="file"
                                        accept="image/png, image/jpeg, application/pdf"
                                        onChange={handleFile}
                                    />
                                    <p>
                                        {' '}
                                        O pagamento será considerado capturado
                                        automaticamente. Envie o arquivo do
                                        comprovante de pagamento (JPG, PNG ou
                                        PDF) acima e posteriormente comunique o
                                        Gate sobre este pagamento manual.{' '}
                                    </p>
                                </>
                            )}
                            <br />
                            {['Invoice'].includes(newPayment)
                                ? 'O pagamento será considerado Capturado automaticamente. Em seguida, efetue manualmente as reservas do pedido e reprocessar no Gate se aplicável.'
                                : ''}
                            {['Transfer', 'Link'].includes(newPayment)
                                ? 'Um novo link será gerado. A emissão será efetuada automaticamente após a confirmação do pagamento'
                                : ''}
                        </p>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                addPayment(orderInfo?.id, newPayment)
                                setPaymentModalOpen(false)
                                uploadAttachment(orderInfo?.id)
                            }}
                            color="primary"
                        >
                            Inserir Novo Pagamento
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog // enviar Gate
                    open={sendGateModalOpen}
                    onClose={() => setSendGateModalOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            CUIDADO! Tem certeza quer reprocessar o XML
                            novamente para o Gate? Verifique com Belvitur se
                            este pedido já não foi recebido no Gate antes de
                            seguir.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                sendGate(orderInfo?.id)
                                setSendGateModalOpen(false)
                            }}
                            color="primary"
                        >
                            Enviar
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog // Adicionar tag
                    open={openNewTagDialog}
                    onClose={() => setOpenNewTagDialog(false)}
                    maxWidth="lg"
                >
                    <DialogContent>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                        >
                            <InputLabel id="demo-simple-select-outlined-label">
                                Nova Tag
                            </InputLabel>
                            <Select
                                labelId="newTag-label"
                                id="newTag"
                                value={newTag}
                                onChange={(e) =>
                                    handleChangeNewTag(e.target.value)
                                }
                                label="Nova Tag"
                            >
                                {tagOptions &&
                                    tagOptions.map((tag) => (
                                        <MenuItem value={tag.id}>
                                            {tag.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => newProductTag(orderInfo?.id)}
                            color="primary"
                        >
                            Confirmar
                        </Button>
                        <Button
                            onClick={() => setOpenNewTagDialog(false)}
                            color="primary"
                            autoFocus
                        >
                            Cancelar
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog // remover tag
                    open={removeTagModalOpen}
                    onClose={() => setRemoveTagModalOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Tem certeza que deseja remover a tag?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                removeTag()
                                setRemoveTagModalOpen(false)
                            }}
                            color="primary"
                        >
                            Sim
                        </Button>
                        <Button
                            onClick={() => setRemoveTagModalOpen(false)}
                            color="primary"
                            autoFocus
                        >
                            Não
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog // Adicionar agente
                    open={openNewAgentDialog}
                    onClose={() => setOpenNewAgentDialog(false)}
                    maxWidth="lg"
                >
                    <DialogContent>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                        >
                            <InputLabel id="demo-simple-select-outlined-label">
                                Nova Agente
                            </InputLabel>
                            <Select
                                labelId="newAgent-label"
                                id="newAgent"
                                value={newAgent}
                                onChange={(e) =>
                                    handleChangeNewAgent(e.target.value)
                                }
                                label="Nova Agente"
                            >
                                {users &&
                                    users.map((user) => (
                                        <MenuItem value={user.id}>
                                            {user.email}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => newAgentOrder(orderInfo?.id)}
                            color="primary"
                        >
                            Confirmar
                        </Button>
                        <Button
                            onClick={() => setOpenNewAgentDialog(false)}
                            color="primary"
                            autoFocus
                        >
                            Cancelar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog // reenviar email de pagamento pix
                    open={forceResendOrderEmailModalOpen}
                    onClose={() => setForceResendOrderEmailModalOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Insira o email do cliente
                            <p>
                                <input
                                    type="email"
                                    label="email@exmaple.com"
                                    onChange={(e) =>
                                        setOrderEmail(e.target.value)
                                    }
                                />
                            </p>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Button
                            onClick={() => {
                                resendOrderEmail()
                                setForceResendOrderEmailModalOpen(false)
                            }}
                            color="primary"
                        >
                            Enviar
                        </Button>
                        <Button
                            onClick={() =>
                                setForceResendOrderEmailModalOpen(false)
                            }
                            color="primary"
                            autoFocus
                        >
                            Não
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog // EMITIDO MANUALMENTE - 1º Etapa
                    open={issuedManuallyFirstStep}
                    onClose={() => setIssuedManuallyFirstStep(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth
                    maxWidth="lg"
                >
                    <DialogContent>
                        <DialogTitle>
                            Anexar voucher emitido manualmente
                        </DialogTitle>
                        <DialogContentText id="alert-dialog-description">
                            <ol>
                                <li>
                                    Verifique no histórico do pedido o motivo do
                                    erro da emissão. Se for um erro de código do
                                    produto, edite o produto com o código
                                    correto e clique em “Emitir Voucher” para
                                    tentar novamente a emissão via sistema.
                                </li>
                                <li>
                                    Caso não consiga emitir via sistema, antes
                                    certifique-se de que não há apólice emitida
                                    para os segurados no portal da seguradora.
                                </li>
                                <li>
                                    Faça a emissão manual no portal e insira o
                                    código do voucher abaixo.
                                </li>
                            </ol>

                            <hr />

                            {orderInfo?.Insurer?.id === 9 ||
                                (orderInfo?.Insurer?.id === 14 && (
                                    <p>
                                        <span style={{ fontWeight: 'bold' }}>
                                            OBS:
                                        </span>{' '}
                                        O código do voucher deve ser anexado
                                        juntamente com o código da operação,
                                        conforme o exemplo abaixo
                                    </p>
                                ))}

                            <hr />
                            <div>
                                <h4>Dados do novo voucher:</h4>
                                {orderInfo?.Passengers &&
                                    orderInfo?.Passengers.map(
                                        (pax, paxIndex) => (
                                            <div key={paxIndex}>
                                                <h4>Segurado {paxIndex + 1}</h4>
                                                <div
                                                    style={{
                                                        marginBottom: '5px',
                                                        border: '1px solid #ccc',
                                                        padding: '15px',
                                                        borderRadius: '15px',
                                                    }}
                                                >
                                                    <Grid container spacing={3}>
                                                        <Grid
                                                            item
                                                            sm={6}
                                                            md={4}
                                                        >
                                                            <TextField
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                                id="owner"
                                                                value={pax.name}
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                            />
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            sm={6}
                                                            md={4}
                                                        >
                                                            <TextField
                                                                placeholder="CÓDIGO DO VOUCHER"
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                onBlur={(
                                                                    event
                                                                ) =>
                                                                    handleVoucherChange(
                                                                        paxIndex,
                                                                        event
                                                                            .target
                                                                            .value
                                                                    )
                                                                }
                                                            />
                                                        </Grid>

                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                alignItems:
                                                                    'center',
                                                            }}
                                                        >
                                                            <p>
                                                                Exemplo:{' '}
                                                                {
                                                                    insurerVoucherExamples[
                                                                        orderInfo
                                                                            ?.Insurer
                                                                            .id
                                                                    ]
                                                                }
                                                            </p>
                                                        </div>
                                                    </Grid>
                                                </div>
                                            </div>
                                        )
                                    )}
                            </div>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ marginBottom: '20px' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ backgroundColor: 'blue' }}
                            onClick={() =>
                                addVoucherCode(orderInfo?.Insurer.id)
                            }
                        >
                            Consultar
                        </Button>
                        <Button
                            onClick={() => setIssuedManuallyFirstStep(false)}
                            color="primary"
                            variant="outlined"
                            autoFocus
                        >
                            Voltar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog // EMITIDO MANUALMENTE - 2º Etapa
                    open={issuedManuallySecondStep}
                    onClose={() => setIssuedManuallySecondStep(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth
                    maxWidth="lg"
                >
                    <DialogContent>
                        <DialogTitle>
                            Anexar voucher emitido manualmente
                        </DialogTitle>
                        <DialogContentText id="alert-dialog-description">
                            <ol>
                                <li>
                                    Verifique no histórico do pedido o motivo do
                                    erro da emissão. Se for um erro de código do
                                    produto, edite o produto com o código
                                    correto e clique em “Emitir Voucher” para
                                    tentar novamente a emissão via sistema.
                                </li>
                                <li>
                                    Caso não consiga emitir via sistema, antes
                                    certifique-se de que não há apólice emitida
                                    para os segurados no portal da seguradora.
                                </li>
                                <li>
                                    Faça a emissão manual no portal e insira o
                                    código do voucher abaixo.
                                </li>
                            </ol>

                            <hr />
                            <div>
                                <h4>Dados do novo voucher:</h4>
                                {orderInfo?.Passengers &&
                                    orderInfo?.Passengers.map(
                                        (pax, paxIndex) => (
                                            <div key={paxIndex}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'baseline',
                                                    }}
                                                >
                                                    <h4
                                                        style={{
                                                            margin: '0px 10px 0px 0px',
                                                        }}
                                                    >
                                                        Segurado {paxIndex + 1}
                                                    </h4>
                                                </div>
                                                <div
                                                    style={{
                                                        marginBottom: '20px',
                                                        border: '1px solid #ccc',
                                                        padding: '15px',
                                                        borderRadius: '15px',
                                                    }}
                                                >
                                                    <Grid container spacing={3}>
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={3}
                                                        >
                                                            <TextField
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                                id="owner"
                                                                value={pax.name}
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={3}
                                                        >
                                                            <TextField
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                id="paxCpf"
                                                                value={pax.cpf}
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={3}
                                                        >
                                                            <TextField
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                id="paxDob"
                                                                value={formatDate(
                                                                    pax.dob
                                                                )}
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={3}
                                                        >
                                                            <TextField
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                                id="markup"
                                                                value={
                                                                    pax.markup
                                                                }
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={3}>
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={2}
                                                        >
                                                            <TextField
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                                id="voucher"
                                                                value={
                                                                    passengersVouchers[
                                                                        paxIndex
                                                                    ]?.voucher
                                                                }
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={2}
                                                        >
                                                            <TextField
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                                id="voucherStatus"
                                                                value={
                                                                    passengersVouchers[
                                                                        paxIndex
                                                                    ]?.status
                                                                        ? 'Emitido'
                                                                        : 'Falha'
                                                                }
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={4}
                                                        >
                                                            <TextField
                                                                InputProps={{
                                                                    endAdornment:
                                                                        (
                                                                            <ContentCopyIcon
                                                                                onClick={() =>
                                                                                    navigator.clipboard.writeText(
                                                                                        passengersVouchers[
                                                                                            paxIndex
                                                                                        ]
                                                                                            ?.voucherUrl
                                                                                    )
                                                                                }
                                                                                cursor={
                                                                                    'pointer'
                                                                                }
                                                                            />
                                                                        ),
                                                                    readOnly: true,
                                                                }}
                                                                id="voucherUrlPt"
                                                                value={
                                                                    passengersVouchers[
                                                                        paxIndex
                                                                    ]
                                                                        ?.voucherUrl
                                                                }
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={4}
                                                        >
                                                            <TextField
                                                                InputProps={{
                                                                    endAdornment:
                                                                        (
                                                                            <ContentCopyIcon
                                                                                onClick={() =>
                                                                                    navigator.clipboard.writeText(
                                                                                        passengersVouchers[
                                                                                            paxIndex
                                                                                        ]
                                                                                            ?.voucherUrlEn
                                                                                    )
                                                                                }
                                                                                cursor={
                                                                                    'pointer'
                                                                                }
                                                                            />
                                                                        ),
                                                                    readOnly: true,
                                                                }}
                                                                id="voucherUrlEn"
                                                                value={
                                                                    passengersVouchers[
                                                                        paxIndex
                                                                    ]
                                                                        ?.voucherUrlEn
                                                                }
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            </div>
                                        )
                                    )}
                            </div>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ marginBottom: '20px' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ backgroundColor: 'green' }}
                            onClick={() =>
                                handleUpdateVoucherPassengers(
                                    orderInfo?.id,
                                    orderInfo?.Passengers
                                )
                            }
                        >
                            ANEXAR APOLICES NO PEDIDO
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => setIssuedManuallySecondStep(false)}
                            color="primary"
                            autoFocus
                        >
                            Voltar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* EDITAR PEDIDO */}
                {/* MODAL PRINCIPAL */}
                <Dialog
                    open={mainlyCancelVoucherModal}
                    onClose={() => setMainlyCancelVoucherModal(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth
                    maxWidth="lg"
                >
                    <DialogContent>
                        <h3>Segurados / Vouchers</h3>
                        <DialogContentText id="alert-dialog-description">
                            <div style={{ display: 'flex', gap: '10px' }}>
                                {combinedInsurersIds.includes(
                                    orderInfo?.Insurer?.id
                                ) && (
                                    <Button
                                        onClick={() =>
                                            setIssuedVoucherFirstStepModal(true)
                                        }
                                        color="secondary"
                                        variant="contained"
                                        autoFocus
                                        style={{ backgroundColor: '#356BF6' }}
                                    >
                                        EMITIR VOUCHER SUBSTITUTO PARA TODOS OS
                                        SEGURADOS
                                    </Button>
                                )}

                                {combinedInsurersIds.includes(
                                    record?.Insurer?.id
                                ) && (
                                    <Button
                                        onClick={() => {
                                            setAttachmentManuallyFirstStep(true)
                                            setPaxIndividualIndex(0)
                                        }}
                                        color="default"
                                        variant="contained"
                                        autoFocus
                                        style={{
                                            backgroundColor: '#868686',
                                            color: 'white',
                                        }}
                                    >
                                        ANEXAR VOUCHER SUBSTITUTO
                                    </Button>
                                )}

                                {combinedInsurersIds.includes(
                                    record?.Insurer?.id
                                ) && (
                                    <Button
                                        onClick={() =>
                                            setCancelIndividualVoucherModalFunction(
                                                0
                                            )
                                        }
                                        color="default"
                                        variant="contained"
                                        autoFocus
                                        style={{
                                            backgroundColor: '#F63535',
                                            color: 'white',
                                            display: `${
                                                record.Passengers.filter(
                                                    (passenger) =>
                                                        passenger.voucherStatus !==
                                                        'Emitido'
                                                ).length >=
                                                record.Passengers.length
                                                    ? 'none'
                                                    : 'block'
                                            }`,
                                        }}
                                    >
                                        CANCELAR TODOS VOUCHER
                                    </Button>
                                )}
                            </div>

                            <div
                                style={{
                                    margin: '20px 0px',
                                    border: '1px solid #A9A9A9',
                                }}
                            ></div>

                            {orderInfo?.Passengers &&
                                orderInfo?.Passengers.map((pax, paxIndex) => (
                                    <Paper
                                        key={paxIndex}
                                        style={{
                                            padding: '10px',
                                            marginBottom: '20px',
                                        }}
                                    >
                                        <h4
                                            style={{
                                                margin: '0px 0px 10px 0px',
                                            }}
                                        >
                                            Segurado {paxIndex + 1}
                                        </h4>

                                        <Grid container spacing={4}>
                                            <Grid item sm={12} md={3}>
                                                <TextField
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                    id="owner"
                                                    label="Responsável"
                                                    value={pax.name}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item sm={12} md={3}>
                                                <TextField
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    id="paxCpf"
                                                    label="Cpf"
                                                    value={pax.cpf}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item sm={12} md={3}>
                                                <TextField
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    id="paxDob"
                                                    label="Nascimento"
                                                    value={formatDate(pax.dob)}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item sm={12} md={3}>
                                                <TextField
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                    id="markup"
                                                    label="Markup R$"
                                                    value={pax.markup}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={3}>
                                            <Grid item sm={12} md={3}>
                                                <TextField
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                    id="voucher"
                                                    label="Voucher"
                                                    value={pax.voucher}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item sm={12} md={3}>
                                                <TextField
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                    id="voucherStatus"
                                                    label="voucherStatus"
                                                    value={pax.voucherStatus}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    style={{
                                                        backgroundColor:
                                                            changeBackgroundByVoucherStatus(
                                                                pax?.voucherStatus
                                                            ),
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item sm={12} md={3}>
                                                <TextField
                                                    InputProps={{
                                                        endAdornment: (
                                                            <ContentCopyIcon
                                                                onClick={() =>
                                                                    navigator.clipboard.writeText(
                                                                        pax.voucherUrl
                                                                    )
                                                                }
                                                                cursor={
                                                                    'pointer'
                                                                }
                                                            />
                                                        ),
                                                        readOnly: true,
                                                    }}
                                                    id="voucherUrlPt"
                                                    label="VoucherUrlPt"
                                                    value={pax.voucherUrl}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item sm={12} md={3}>
                                                <TextField
                                                    InputProps={{
                                                        endAdornment: (
                                                            <ContentCopyIcon
                                                                onClick={() =>
                                                                    navigator.clipboard.writeText(
                                                                        pax.voucherUrlEn
                                                                    )
                                                                }
                                                                cursor={
                                                                    'pointer'
                                                                }
                                                            />
                                                        ),
                                                        readOnly: true,
                                                    }}
                                                    id="voucherUrlEn"
                                                    label="VoucherUrlEn"
                                                    value={pax.voucherUrlEn}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid>

                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'start',
                                                alignItems: 'center',
                                                paddingTop: 10,
                                                gap: 20,
                                            }}
                                        >
                                            {!combinedInsurersIds.includes(
                                                orderInfo?.Insurer?.id
                                            ) &&
                                                pax?.voucherStatus !==
                                                    'Cancelado' && (
                                                    <Button
                                                        onClick={() =>
                                                            setCancelIndividualVoucherModalFunction(
                                                                paxIndex
                                                            )
                                                        }
                                                        color="default"
                                                        variant="contained"
                                                        autoFocus
                                                        style={{
                                                            backgroundColor:
                                                                '#F63535',
                                                            color: 'white',
                                                        }}
                                                    >
                                                        CANCELAR VOUCHER
                                                        (INDIVIDUAL)
                                                    </Button>
                                                )}
                                            {!combinedInsurersIds.includes(
                                                orderInfo?.Insurer?.id
                                            ) && (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        gap: 20,
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    {pax?.voucherStatus ===
                                                    'Emitido' ? (
                                                        <Button
                                                            // onClick={() => setMainlyCancelVoucherModal(false)}
                                                            color="default"
                                                            variant="contained"
                                                            autoFocus
                                                            // style={{ backgroundColor: "#356BF6", color: 'white' }}
                                                            disabled={
                                                                pax?.voucherStatus ===
                                                                'Emitido'
                                                            }
                                                            sx={{
                                                                backgroundColor:
                                                                    '#356BF6',
                                                                color: 'white',
                                                                '&.Mui-disabled':
                                                                    {
                                                                        backgroundColor:
                                                                            '#A0A0A0', // cor desejada quando desabilitado
                                                                        color: '#fff', // cor do texto quando desabilitado
                                                                        opacity: 1, // opcional, evita que fique "apagado"
                                                                        cursor: 'not-allowed',
                                                                    },
                                                            }}
                                                        >
                                                            EMITIR VOUCHER
                                                            SUBSTITUTO
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            onClick={() => {
                                                                setIssuedVoucherFirstStepModal(
                                                                    true
                                                                )
                                                                setPaxIndividualIndex(
                                                                    paxIndex
                                                                )
                                                            }}
                                                            color="default"
                                                            variant="contained"
                                                            autoFocus
                                                            style={{
                                                                backgroundColor:
                                                                    '#356BF6',
                                                                color: 'white',
                                                            }}
                                                            disabled={
                                                                pax?.voucherStatus ===
                                                                'Emitido'
                                                            }
                                                        >
                                                            EMITIR VOUCHER
                                                            SUBSTITUTO
                                                        </Button>
                                                    )}
                                                    {!combinedInsurersIds.includes(
                                                        orderInfo?.Insurer?.id
                                                    ) && (
                                                        <Button
                                                            onClick={() => {
                                                                setAttachmentManuallyFirstStep(
                                                                    true
                                                                )
                                                                setPaxIndividualIndex(
                                                                    paxIndex
                                                                )
                                                            }}
                                                            color="default"
                                                            variant="contained"
                                                            autoFocus
                                                            style={{
                                                                backgroundColor:
                                                                    '#868686',
                                                                color: 'white',
                                                            }}
                                                        >
                                                            ANEXAR VOUCHER
                                                            SUBSTITUTO
                                                        </Button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </Paper>
                                ))}

                            <p style={{ fontWeight: 'bold', color: 'black' }}>
                                Vouchers cancelados/substituidos
                            </p>

                            {vouchersCanceledList.length > 0 &&
                                vouchersCanceledList.map((pax) => (
                                    <Grid container spacing={4}>
                                        <Grid item sm={12} md={3}>
                                            <TextField
                                                InputProps={{ readOnly: true }}
                                                id="owner"
                                                label="Segurado"
                                                value={pax.name}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item sm={12} md={3}>
                                            <TextField
                                                InputProps={{ readOnly: true }}
                                                id="voucher"
                                                label="Voucher"
                                                value={pax.voucher}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item sm={12} md={3}>
                                            <TextField
                                                InputProps={{ readOnly: true }}
                                                id="voucherStatus"
                                                label="Status"
                                                value={pax.voucherStatus}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                style={{
                                                    backgroundColor:
                                                        changeBackgroundByVoucherStatus(
                                                            pax?.voucherStatus
                                                        ),
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                ))}

                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'end',
                                }}
                            >
                                <Button
                                    style={{ marginTop: '20px' }}
                                    onClick={() =>
                                        setMainlyCancelVoucherModal(false)
                                    }
                                    color="primary"
                                    variant="outlined"
                                    autoFocus
                                >
                                    Voltar
                                </Button>
                            </div>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>

                {/* MODAL DE CANCELAMENTO INDIVIDUAL */}
                <Dialog
                    open={cancelIndividualVoucherModal}
                    onClose={() => setCancelIndividualVoucherModal(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth
                    maxWidth="md"
                >
                    <DialogContent>
                        <h2>
                            Cancelar voucher individual -{' '}
                            {orderInfo?.Passengers[paxIndividualIndex]?.name}
                        </h2>
                        <p>
                            <span style={{ fontWeight: 'bold' }}>Atenção:</span>{' '}
                            Essa operação não gera automaticamente nenhum
                            estorno ao cliente no sistema; isso deve ser feito
                            manualmente.
                        </p>
                        <DialogContentText id="alert-dialog-description">
                            <Button
                                onClick={() =>
                                    cancelPassengerVoucher(
                                        orderInfo?.Insurer?.id,
                                        orderInfo?.Passengers[
                                            paxIndividualIndex
                                        ]?.voucher
                                    )
                                }
                                color="default"
                                variant="contained"
                                autoFocus
                                style={{
                                    backgroundColor: '#F63535',
                                    color: 'white',
                                }}
                            >
                                {combinedInsurersIds.includes(
                                    orderInfo?.Insurer?.id
                                )
                                    ? 'CANCELAR TODOS OS VOUCHERS'
                                    : ' CANCELAR VOUCHER (INDIVIDUAL)'}
                            </Button>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'end',
                                }}
                            >
                                <Button
                                    style={{ marginTop: '20px' }}
                                    onClick={() =>
                                        setCancelIndividualVoucherModal(false)
                                    }
                                    color="primary"
                                    variant="outlined"
                                    autoFocus
                                >
                                    Voltar
                                </Button>
                            </div>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>

                {/* MODAL DE ERRO CANCELAMENTO INDIVIDUAL */}
                <Dialog
                    open={cancelIndividualVoucherErrorModal}
                    onClose={() => setCancelIndividualVoucherErrorModal(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth
                    maxWidth="md"
                >
                    <DialogContent>
                        <h2>
                            Cancelar voucher individual -{' '}
                            {orderInfo?.Passengers[paxIndividualIndex]?.name}
                        </h2>
                        <p>
                            Ocorreu um erro no cancelamento via API. Tente
                            novamente ou faça o cancelamento no portal da
                            seguradora e clique em "Verificar".
                        </p>
                        <DialogContentText id="alert-dialog-description">
                            <div style={{ display: 'flex', gap: 10 }}>
                                <Button
                                    onClick={() =>
                                        cancelPassengerVoucher(
                                            orderInfo?.Insurer?.id,
                                            orderInfo?.Passengers[
                                                paxIndividualIndex
                                            ]?.voucher
                                        )
                                    }
                                    color="default"
                                    variant="contained"
                                    autoFocus
                                    style={{
                                        backgroundColor: '#F63535',
                                        color: 'white',
                                    }}
                                >
                                    {combinedInsurersIds.includes(
                                        orderInfo?.Insurer?.id
                                    )
                                        ? 'CANCELAR TODOS OS VOUCHERS'
                                        : ' CANCELAR VOUCHER (INDIVIDUAL)'}
                                </Button>

                                <Button
                                    onClick={() =>
                                        verifyVoucherStatus(
                                            orderInfo?.Insurer?.id,
                                            orderInfo?.Passengers[
                                                paxIndividualIndex
                                            ]?.voucher
                                        )
                                    }
                                    color="default"
                                    variant="contained"
                                    autoFocus
                                    style={{
                                        backgroundColor: '#F63535',
                                        color: 'white',
                                    }}
                                >
                                    CANCELADO MANUALMENTE - VERIFICAR
                                </Button>
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'end',
                                }}
                            >
                                <Button
                                    style={{ marginTop: '20px' }}
                                    onClick={() =>
                                        setCancelIndividualVoucherErrorModal(
                                            false
                                        )
                                    }
                                    color="primary"
                                    variant="outlined"
                                    autoFocus
                                >
                                    Voltar
                                </Button>
                            </div>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>

                {/* MODAL DE VERIFICAR SE O VOUCHER FOI CANCELADO APOS DAR O ERRO, POIS DEVE SER FEITO NO PORTAL DA SEGURADORA */}
                <Dialog
                    open={verifyVoucherIsCancelledModal}
                    onClose={() => setVerifyVoucherIsCancelledModal(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth
                    maxWidth="md"
                >
                    <DialogContent>
                        <h2>
                            Cancelar voucher individual -{' '}
                            {orderInfo?.Passengers[paxIndividualIndex]?.name}
                        </h2>

                        <DialogContentText id="alert-dialog-description">
                            <div style={{ display: 'flex', gap: 10 }}>
                                <Grid container spacing={4}>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="owner"
                                            label="Segurado"
                                            value={
                                                orderInfo?.Passengers[
                                                    paxIndividualIndex
                                                ]?.name
                                            }
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            id="voucherId"
                                            label="Vouhcer"
                                            value={voucherStatusData?.voucher}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="voucherStatus"
                                            label="voucherStatus"
                                            value={`${
                                                voucherStatusData?.status ==
                                                'true'
                                                    ? 'Cancelado'
                                                    : 'Emitido'
                                            }`}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            style={{
                                                backgroundColor: `${
                                                    voucherStatusData?.status ==
                                                    'true'
                                                        ? '#ffeee4'
                                                        : '#e2ffe7'
                                                }`,
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'end',
                                }}
                            >
                                <Button
                                    style={{ marginTop: '20px' }}
                                    onClick={() =>
                                        setVerifyVoucherIsCancelledModal(false)
                                    }
                                    color="primary"
                                    variant="outlined"
                                    autoFocus
                                >
                                    Voltar
                                </Button>
                            </div>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>

                <Dialog // ANEXAR MANUALMENTE - 1º Etapa
                    open={attachmentManuallyFirstStep}
                    onClose={() => setAttachmentManuallyFirstStep(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth
                    maxWidth="lg"
                >
                    <DialogContent>
                        <h2>
                            Anexar voucher substituto -{' '}
                            {combinedInsurersIds.includes(
                                orderInfo?.Insurer?.id
                            )
                                ? 'Todos os segurados'
                                : orderInfo?.Passengers[paxIndividualIndex]
                                      ?.name}
                        </h2>
                        {orderInfo?.Insurer?.id === 9 ||
                            (orderInfo?.Insurer?.id === 14 && (
                                <p>
                                    <span style={{ fontWeight: 'bold' }}>
                                        OBS:
                                    </span>{' '}
                                    O código do voucher deve ser anexado
                                    juntamente com o código da operação,
                                    conforme o exemplo abaixo
                                </p>
                            ))}
                        <p>
                            <span style={{ fontWeight: 'bold' }}>Atenção:</span>{' '}
                            Antes de anexar um voucher substituto, é necessário
                            cancelar o voucher atual. Essa operação não gera
                            automaticamente nenhum estorno ou cobrança adicional
                            ao cliente no sistema; isso deve ser feito
                            manualmente.
                        </p>
                        <DialogContentText id="alert-dialog-description">
                            <Button
                                onClick={() =>
                                    cancelPassengerVoucher(
                                        orderInfo?.Insurer?.id,
                                        orderInfo?.Passengers[
                                            paxIndividualIndex
                                        ]?.voucher
                                    )
                                }
                                color="default"
                                variant="contained"
                                autoFocus
                                style={{
                                    backgroundColor: '#F63535',
                                    color: 'white',
                                }}
                            >
                                {combinedInsurersIds.includes(
                                    orderInfo?.Insurer?.id
                                )
                                    ? 'CANCELAR TODOS OS VOUCHERS'
                                    : ' CANCELAR VOUCHER (INDIVIDUAL)'}
                            </Button>

                            <div
                                style={{
                                    margin: '20px 0px',
                                    border: '1px solid #A9A9A9',
                                }}
                            ></div>
                        </DialogContentText>
                        <h4>Dados do novo voucher:</h4>
                        {!combinedInsurersIds.includes(
                            orderInfo?.Insurer?.id
                        ) &&
                            orderInfo?.Passengers && (
                                <div>
                                    {!combinedInsurersIds.includes(
                                        orderInfo?.Insurer?.id
                                    ) && (
                                        <h4>
                                            Segurado {paxIndividualIndex + 1}
                                        </h4>
                                    )}
                                    <div>
                                        <Grid container spacing={3}>
                                            {!combinedInsurersIds.includes(
                                                orderInfo?.Insurer?.id
                                            ) && (
                                                <Grid item sm={6} md={4}>
                                                    <TextField
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        id="owner"
                                                        value={
                                                            orderInfo
                                                                ?.Passengers[
                                                                paxIndividualIndex
                                                            ]?.name
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </Grid>
                                            )}

                                            <Grid item sm={6} md={4}>
                                                <TextField
                                                    placeholder="CÓDIGO DO VOUCHER"
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    onBlur={(event) =>
                                                        handleVoucherChange(
                                                            paxIndividualIndex,
                                                            event.target.value
                                                        )
                                                    }
                                                />
                                            </Grid>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <p>
                                                    Exemplo:{' '}
                                                    {
                                                        insurerVoucherExamples[
                                                            orderInfo?.Insurer
                                                                .id
                                                        ]
                                                    }
                                                </p>
                                            </div>
                                        </Grid>
                                    </div>
                                </div>
                            )}
                        {combinedInsurersIds.includes(
                            orderInfo?.Insurer?.id
                        ) && (
                            <div>
                                <Grid container spacing={3}>
                                    <Grid item sm={6} md={4}>
                                        <TextField
                                            placeholder="CÓDIGO DO VOUCHER"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            onBlur={(event) =>
                                                handleVoucherChange(
                                                    0,
                                                    event.target.value
                                                )
                                            }
                                        />
                                    </Grid>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <p>
                                            Exemplo:{' '}
                                            {
                                                insurerVoucherExamples[
                                                    orderInfo?.Insurer.id
                                                ]
                                            }
                                        </p>
                                    </div>
                                </Grid>
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions style={{ marginBottom: '20px' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ backgroundColor: 'blue' }}
                            onClick={() =>
                                addAttachmentVoucherCode(orderInfo?.Insurer.id)
                            }
                        >
                            Consultar
                        </Button>
                        <Button
                            onClick={() =>
                                setAttachmentManuallyFirstStep(false)
                            }
                            color="primary"
                            variant="outlined"
                            autoFocus
                        >
                            Voltar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog // ANEXAR MANUALMENTE - 2º Etapa
                    open={attachmentManuallySecondStep}
                    onClose={() => setAttachmentManuallySecondStep(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth
                    maxWidth="lg"
                >
                    <DialogContent>
                        <h2>
                            Anexar voucher substituto -{' '}
                            {combinedInsurersIds.includes(
                                orderInfo?.Insurer?.id
                            )
                                ? 'Todos os segurados'
                                : orderInfo?.Passengers[paxIndividualIndex]
                                      ?.name}
                        </h2>
                        <p style={{ fontWeight: 'bold' }}>
                            Vouhcers Cancelados:
                        </p>
                        {vouchersCanceledList.length > 0 &&
                            vouchersCanceledList.map((pax) => (
                                <Grid container spacing={4}>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="owner"
                                            label="Segurado"
                                            value={pax.name}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="voucher"
                                            label="Voucher"
                                            value={pax.voucher}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="voucherStatus"
                                            label="Status"
                                            value={pax.voucherStatus}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            style={{
                                                backgroundColor:
                                                    changeBackgroundByVoucherStatus(
                                                        pax?.voucherStatus
                                                    ),
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            ))}

                        <hr />
                        <div>
                            <h4 style={{ fontWeight: 'bold' }}>
                                Dados do novo voucher:
                            </h4>
                            {!combinedInsurersIds.includes(
                                orderInfo?.Insurer?.id
                            ) &&
                                orderInfo?.Passengers && (
                                    <div>
                                        <div>
                                            <h4
                                                style={{
                                                    margin: '10px 0px',
                                                }}
                                            >
                                                Segurado{' '}
                                                {paxIndividualIndex + 1}
                                            </h4>
                                        </div>
                                        <div>
                                            <Grid container spacing={3}>
                                                <Grid item sm={12} md={3}>
                                                    <TextField
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        id="owner"
                                                        value={
                                                            orderInfo
                                                                ?.Passengers[
                                                                paxIndividualIndex
                                                            ]?.name
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item sm={12} md={3}>
                                                    <TextField
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        id="paxCpf"
                                                        value={
                                                            orderInfo
                                                                ?.Passengers[
                                                                paxIndividualIndex
                                                            ]?.cpf
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item sm={12} md={3}>
                                                    <TextField
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        id="paxDob"
                                                        value={formatDate(
                                                            orderInfo
                                                                ?.Passengers[
                                                                paxIndividualIndex
                                                            ]?.dob
                                                        )}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item sm={12} md={3}>
                                                    <TextField
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        id="markup"
                                                        value={
                                                            orderInfo
                                                                ?.Passengers[
                                                                paxIndividualIndex
                                                            ]?.markup
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={3}>
                                                <Grid item sm={12} md={2}>
                                                    <TextField
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        id="voucher"
                                                        value={
                                                            passengersVouchers[
                                                                paxIndividualIndex
                                                            ]?.voucher
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item sm={12} md={2}>
                                                    <TextField
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        id="voucherStatus"
                                                        value={
                                                            passengersVouchers[
                                                                paxIndividualIndex
                                                            ]?.status
                                                                ? 'Emitido'
                                                                : 'Cancelado'
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        style={{
                                                            backgroundColor: `${
                                                                passengersVouchers[
                                                                    paxIndividualIndex
                                                                ]?.status
                                                                    ? '#e2ffe7'
                                                                    : '#FFE3E3'
                                                            }`,
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item sm={12} md={4}>
                                                    <TextField
                                                        InputProps={{
                                                            endAdornment: (
                                                                <ContentCopyIcon
                                                                    onClick={() =>
                                                                        navigator.clipboard.writeText(
                                                                            passengersVouchers[
                                                                                paxIndividualIndex
                                                                            ]
                                                                                ?.voucherUrl
                                                                        )
                                                                    }
                                                                    cursor={
                                                                        'pointer'
                                                                    }
                                                                />
                                                            ),
                                                            readOnly: true,
                                                        }}
                                                        id="voucherUrlPt"
                                                        value={
                                                            passengersVouchers[
                                                                paxIndividualIndex
                                                            ]?.voucherUrl
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item sm={12} md={4}>
                                                    <TextField
                                                        InputProps={{
                                                            endAdornment: (
                                                                <ContentCopyIcon
                                                                    onClick={() =>
                                                                        navigator.clipboard.writeText(
                                                                            passengersVouchers[
                                                                                paxIndividualIndex
                                                                            ]
                                                                                ?.voucherUrlEn
                                                                        )
                                                                    }
                                                                    cursor={
                                                                        'pointer'
                                                                    }
                                                                />
                                                            ),
                                                            readOnly: true,
                                                        }}
                                                        id="voucherUrlEn"
                                                        value={
                                                            passengersVouchers[
                                                                paxIndividualIndex
                                                            ]?.voucherUrlEn
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                                )}

                            {combinedInsurersIds.includes(
                                orderInfo?.Insurer?.id
                            ) &&
                                orderInfo?.Passengers &&
                                orderInfo?.Passengers.map((pax, paxIndex) => (
                                    <div key={paxIndex}>
                                        <h4
                                            style={{
                                                margin: '5px 0px',
                                            }}
                                        >
                                            Segurado {paxIndex + 1}
                                        </h4>
                                        <div style={{ marginBottom: '20px' }}>
                                            <Grid container spacing={3}>
                                                <Grid item sm={12} md={3}>
                                                    <TextField
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        id="owner"
                                                        value={pax.name}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item sm={12} md={3}>
                                                    <TextField
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        id="paxCpf"
                                                        value={pax.cpf}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item sm={12} md={3}>
                                                    <TextField
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        id="paxDob"
                                                        value={formatDate(
                                                            pax.dob
                                                        )}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={3}>
                                                <Grid item sm={12} md={2}>
                                                    <TextField
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        id="voucher"
                                                        value={
                                                            passengersVouchers[
                                                                paxIndex
                                                            ]?.voucher
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item sm={12} md={2}>
                                                    <TextField
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        id="voucherStatus"
                                                        value={
                                                            passengersVouchers[
                                                                paxIndex
                                                            ]?.status
                                                                ? 'Emitido'
                                                                : 'Falha'
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item sm={12} md={4}>
                                                    <TextField
                                                        InputProps={{
                                                            endAdornment: (
                                                                <ContentCopyIcon
                                                                    onClick={() =>
                                                                        navigator.clipboard.writeText(
                                                                            passengersVouchers[
                                                                                paxIndex
                                                                            ]
                                                                                ?.voucherUrl
                                                                        )
                                                                    }
                                                                    cursor={
                                                                        'pointer'
                                                                    }
                                                                />
                                                            ),
                                                            readOnly: true,
                                                        }}
                                                        id="voucherUrlPt"
                                                        value={
                                                            passengersVouchers[
                                                                paxIndex
                                                            ]?.voucherUrl
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item sm={12} md={4}>
                                                    <TextField
                                                        InputProps={{
                                                            endAdornment: (
                                                                <ContentCopyIcon
                                                                    onClick={() =>
                                                                        navigator.clipboard.writeText(
                                                                            passengersVouchers[
                                                                                paxIndex
                                                                            ]
                                                                                ?.voucherUrlEn
                                                                        )
                                                                    }
                                                                    cursor={
                                                                        'pointer'
                                                                    }
                                                                />
                                                            ),
                                                            readOnly: true,
                                                        }}
                                                        id="voucherUrlEn"
                                                        value={
                                                            passengersVouchers[
                                                                paxIndex
                                                            ]?.voucherUrlEn
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </DialogContent>
                    <DialogActions style={{ marginBottom: '20px' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ backgroundColor: 'green' }}
                            onClick={() =>
                                handleUpdateAttachmentVoucherPassengers(
                                    orderInfo?.id,
                                    orderInfo?.Passengers
                                )
                            }
                        >
                            ANEXAR APOLICES NO PEDIDO
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() =>
                                setAttachmentManuallySecondStep(false)
                            }
                            color="primary"
                            autoFocus
                        >
                            Voltar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog // EMITIR VOUHCER SUBSTITUTO - 1º Etapa
                    open={issuedVoucherFirstStepModal}
                    onClose={() => setIssuedVoucherFirstStepModal(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth
                    maxWidth="lg"
                >
                    <DialogContent>
                        <h2>
                            Emitir voucher substituto -{' '}
                            {combinedInsurersIds.includes(
                                orderInfo?.Insurer?.id
                            )
                                ? 'Todos os segurados'
                                : orderInfo?.Passengers[paxIndividualIndex]
                                      ?.name}
                        </h2>
                        <p style={{ fontWeight: 'bold' }}>
                            Vouhcers Cancelados:
                        </p>
                        {vouchersCanceledList.length > 0 &&
                            vouchersCanceledList.map((pax) => (
                                <Grid container spacing={4}>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="owner"
                                            label="Segurado"
                                            value={pax.name}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="voucher"
                                            label="Voucher"
                                            value={pax.voucher}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="voucherStatus"
                                            label="Status"
                                            value={pax.voucherStatus}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            style={{
                                                backgroundColor:
                                                    changeBackgroundByVoucherStatus(
                                                        pax?.voucherStatus
                                                    ),
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            ))}

                        <hr />
                        <div>
                            <h4 style={{ fontWeight: 'bold' }}>
                                Endereço do comprador
                            </h4>
                            <div style={{ marginBottom: '20px' }}>
                                <Grid container spacing={3}>
                                    <Grid item sm={12} md={2}>
                                        <TextField
                                            id="ownerCep"
                                            value={recordData?.ownerCep}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            label={'CEP'}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                updateRecordAddressField(
                                                    'ownerCep',
                                                    value
                                                )
                                                setPassengerCep(value)
                                            }}
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            id="ownerAddress"
                                            value={recordData?.ownerAddress}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            label={'Endereço'}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                updateRecordAddressField(
                                                    'ownerAddress',
                                                    value
                                                )
                                                setPassengerAddress(value)
                                            }}
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={2}>
                                        <TextField
                                            id="ownerState"
                                            value={recordData?.ownerState}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            label={'Estado'}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                updateRecordAddressField(
                                                    'ownerState',
                                                    value
                                                )
                                                setPassengerState(value)
                                            }}
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={2}>
                                        <TextField
                                            id="ownerComplement"
                                            value={recordData?.ownerComplement}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            label={'Complemento'}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                updateRecordAddressField(
                                                    'ownerComplement',
                                                    value
                                                )
                                                setPassengerComplement(value)
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid item sm={12} md={2}>
                                        <TextField
                                            id="ownerNumber"
                                            value={recordData?.ownerNumber}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            label={'Número'}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                updateRecordAddressField(
                                                    'ownerNumber',
                                                    value
                                                )
                                                setPassengerNumber(value)
                                            }}
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            id="ownerDistrict"
                                            value={recordData?.ownerDistrict}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            label={'Bairro'}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                updateRecordAddressField(
                                                    'ownerDistrict',
                                                    value
                                                )
                                                setPassengerDistrict(value)
                                            }}
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            id="ownerCity"
                                            value={recordData?.ownerCity}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            label={'Cidade'}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                updateRecordAddressField(
                                                    'ownerCity',
                                                    value
                                                )
                                                setPassengerCity(value)
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </div>

                            <h4 style={{ fontWeight: 'bold' }}>
                                Dados do segurado
                            </h4>

                            {!combinedInsurersIds.includes(
                                orderInfo?.Insurer?.id
                            ) &&
                                orderInfo?.Passengers && (
                                    <div>
                                        <div>
                                            <Grid container spacing={4}>
                                                <Grid item sm={12} md={5}>
                                                    <TextField
                                                        id="owner"
                                                        value={
                                                            recordData
                                                                ?.Passengers[
                                                                paxIndividualIndex
                                                            ]?.name
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        label={'Nome'}
                                                        onChange={(e) => {
                                                            const newValue =
                                                                e.target.value.toUpperCase()

                                                            const updatedPassenger =
                                                                {
                                                                    ...recordData
                                                                        ?.Passengers[
                                                                        paxIndividualIndex
                                                                    ],
                                                                    name: newValue,
                                                                }

                                                            updatePassengerInRecord(
                                                                paxIndividualIndex,
                                                                updatedPassenger
                                                            )
                                                            handleInputChangeNewVoucherData(
                                                                paxIndividualIndex,
                                                                'name',
                                                                updatedPassenger?.name
                                                            )
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item sm={12} md={3}>
                                                    <TextField
                                                        id="paxCpf"
                                                        value={
                                                            recordData
                                                                ?.Passengers[
                                                                paxIndividualIndex
                                                            ]?.cpf
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        label={'CPF'}
                                                        onChange={(e) => {
                                                            const newValue =
                                                                e.target.value.toUpperCase()

                                                            const updatedPassenger =
                                                                {
                                                                    ...recordData
                                                                        ?.Passengers[
                                                                        paxIndividualIndex
                                                                    ],
                                                                    cpf: newValue,
                                                                }

                                                            updatePassengerInRecord(
                                                                paxIndividualIndex,
                                                                updatedPassenger
                                                            )
                                                            handleInputChangeNewVoucherData(
                                                                paxIndividualIndex,
                                                                'cpf',
                                                                updatedPassenger?.cpf
                                                            )
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item sm={12} md={3}>
                                                    <TextField
                                                        id="paxDob"
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        value={formatDate(
                                                            recordData
                                                                ?.Passengers[
                                                                paxIndividualIndex
                                                            ]?.dob
                                                        )}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        label={'Nascimento'}
                                                        onChange={(e) => {
                                                            const newValue =
                                                                e.target.value

                                                            const updatedPassenger =
                                                                {
                                                                    ...recordData
                                                                        ?.Passengers[
                                                                        paxIndividualIndex
                                                                    ],
                                                                    dob: newValue,
                                                                }

                                                            updatePassengerInRecord(
                                                                paxIndividualIndex,
                                                                updatedPassenger
                                                            )
                                                            handleInputChangeNewVoucherData(
                                                                paxIndividualIndex,
                                                                'dob',
                                                                updatedPassenger?.dob
                                                            )
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                                )}
                            <hr />

                            {combinedInsurersIds.includes(
                                orderInfo?.Insurer?.id
                            ) &&
                                orderInfo?.Passengers &&
                                orderInfo?.Passengers.map((pax, paxIndex) => (
                                    <div key={paxIndex}>
                                        <h4
                                            style={{
                                                margin: '5px 0px',
                                            }}
                                        >
                                            Segurado {paxIndex + 1}
                                        </h4>
                                        <div style={{ marginBottom: '20px' }}>
                                            <Grid container spacing={4}>
                                                <Grid item sm={12} md={5}>
                                                    <TextField
                                                        id="owner"
                                                        value={
                                                            recordData
                                                                ?.Passengers[
                                                                paxIndex
                                                            ]?.name
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        label={'Nome'}
                                                        onChange={(e) => {
                                                            const newValue =
                                                                e.target.value.toUpperCase()

                                                            const updatedPassenger =
                                                                {
                                                                    ...recordData
                                                                        ?.Passengers[
                                                                        paxIndex
                                                                    ],
                                                                    name: newValue,
                                                                }

                                                            updatePassengerInRecord(
                                                                paxIndex,
                                                                updatedPassenger
                                                            )
                                                            handleInputChangeNewVoucherData(
                                                                paxIndex,
                                                                'name',
                                                                updatedPassenger?.name
                                                            )
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item sm={12} md={3}>
                                                    <TextField
                                                        id="paxCpf"
                                                        value={
                                                            recordData
                                                                ?.Passengers[
                                                                paxIndex
                                                            ]?.cpf
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        label={'CPF'}
                                                        onChange={(e) => {
                                                            const newValue =
                                                                e.target.value.toUpperCase()

                                                            const updatedPassenger =
                                                                {
                                                                    ...recordData
                                                                        ?.Passengers[
                                                                        paxIndex
                                                                    ],
                                                                    cpf: newValue,
                                                                }

                                                            updatePassengerInRecord(
                                                                paxIndex,
                                                                updatedPassenger
                                                            )
                                                            handleInputChangeNewVoucherData(
                                                                paxIndex,
                                                                'cpf',
                                                                updatedPassenger?.cpf
                                                            )
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item sm={12} md={3}>
                                                    <TextField
                                                        id="paxDob"
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        value={formatDate(
                                                            recordData
                                                                ?.Passengers[
                                                                paxIndex
                                                            ]?.dob
                                                        )}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        label={'Nascimento'}
                                                        onChange={(e) => {
                                                            const newValue =
                                                                e.target.value

                                                            const updatedPassenger =
                                                                {
                                                                    ...recordData
                                                                        ?.Passengers[
                                                                        paxIndex
                                                                    ],
                                                                    dob: newValue,
                                                                }

                                                            updatePassengerInRecord(
                                                                paxIndex,
                                                                updatedPassenger
                                                            )
                                                            handleInputChangeNewVoucherData(
                                                                paxIndex,
                                                                'dob',
                                                                updatedPassenger?.dob
                                                            )
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                                ))}

                            <h4 style={{ fontWeight: 'bold' }}>
                                Dados do plano contratado
                            </h4>
                            <hr />
                            <Grid container spacing={5}>
                                <Grid item sm={12} md={3}>
                                    <TextField
                                        InputProps={{ readOnly: true }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        id="productName"
                                        value={orderInfo?.productName}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        label="Nome"
                                    />
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <TextField
                                        InputProps={{ readOnly: true }}
                                        id="checkIn"
                                        value={orderInfo?.checkIn}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        label="Check-in"
                                    />
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <TextField
                                        InputProps={{ readOnly: true }}
                                        id="checkOut"
                                        value={orderInfo?.checkOut}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        label="Check-out"
                                    />
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <TextField
                                        InputProps={{ readOnly: true }}
                                        id="diarias"
                                        value={daysDiff(
                                            orderInfo?.checkOut,
                                            orderInfo?.checkIn
                                        )}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        label="Diarias"
                                    />
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <TextField
                                        InputProps={{ readOnly: true }}
                                        id="markup"
                                        value={Number(orderInfo?.total).toFixed(
                                            2
                                        )}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        label="Valor Total"
                                    />
                                </Grid>
                            </Grid>

                            <h4 style={{ fontWeight: 'bold' }}>
                                Dados do novo plano
                            </h4>
                            <hr />

                            <Grid container spacing={5}>
                                <Grid item sm={12} md={3}>
                                    <select
                                        style={{
                                            height: '40px',
                                            width: '100%',
                                            borderRadius: '10px',
                                            border: '1px solid #ccc',
                                        }}
                                        onChange={(e) => {
                                            const id = e.target.value
                                            setProductId(id)
                                            getProductById(id)
                                            setPassengerId(
                                                orderInfo?.Passengers[
                                                    paxIndividualIndex
                                                ]?.id
                                            )
                                        }}
                                    >
                                        <option value={0}>
                                            {' '}
                                            {products.length > 0
                                                ? 'Selecione o produto'
                                                : 'Selecione as datas e faça a cotação'}
                                        </option>
                                        {products.length > 0 &&
                                            products.map((product) => (
                                                <option value={product.id}>
                                                    {product.name}
                                                </option>
                                            ))}
                                    </select>
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <TextField
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        id="embarque"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        label="Check-In"
                                        type="date"
                                        onChange={(e) =>
                                            setStartDate(e.target.value)
                                        }
                                    />
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <TextField
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        id="desembarque"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        label="Check-Out"
                                        type="date"
                                        onChange={(e) =>
                                            setEndDate(e.target.value)
                                        }
                                    />
                                </Grid>
                                {products.length > 0 && (
                                    <Grid item sm={12} md={2}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="dailys"
                                            value={daysDiff(endDate, startDate)}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            label="Diarias"
                                        />
                                    </Grid>
                                )}
                                {products.length > 0 && (
                                    <Grid item sm={12} md={2}>
                                        <TextField
                                            InputProps={{ readOnly: true }}
                                            id="markup"
                                            value={markup.toFixed(2)}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            label="Valor Total"
                                        />
                                    </Grid>
                                )}
                            </Grid>

                            {markup > orderInfo?.total && (
                                <div
                                    style={{
                                        backgroundColor: '#D6DCA2',
                                        padding: '10px',
                                        marginTop: '20px',
                                        borderRadius: '5px',
                                    }}
                                >
                                    <p>
                                        <span style={{ fontWeight: 'bold' }}>
                                            Upgrade
                                        </span>{' '}
                                        - Foi detectado que o novo valor é
                                        superior ao plano contratado
                                        inicialmente pelo cliente.
                                    </p>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 5,
                                        }}
                                    >
                                        <TextField
                                            size="small"
                                            type="checkbox"
                                            onChange={(e) =>
                                                setIsChecked(e.target.checked)
                                            }
                                        />
                                        <p>
                                            Já foi feita a cobrança adicional e
                                            o cliente efetuou o pagamento.
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </DialogContent>
                    <DialogActions style={{ marginBottom: '20px' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ backgroundColor: 'green' }}
                            onClick={() => getListPlans()}
                        >
                            FAZER COTAÇÃO
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => {
                                issuedNewVoucher()
                                setPassengerId(
                                    orderInfo?.Passengers[paxIndividualIndex]
                                        ?.id
                                )
                            }}
                            color="primary"
                            autoFocus
                            disabled={!isChecked}
                        >
                            EMITIR VOUCHER
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog // EDITAR DADOS DO OWNER
                    open={updateOwnerDateModal}
                    onClose={() => setUpdateOwnerDateModal(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth
                    maxWidth="xl"
                >
                    <DialogContent>
                        <h2>Editar dados do usuário</h2>

                        <h4>Responsável / Pagador</h4>
                        <Paper style={{ padding: '10px' }}>
                            <Grid container spacing={3}>
                                <Grid item sm={12} md={3}>
                                    <TextField
                                        id="ownerName"
                                        label="Nome"
                                        value={recordData?.ownerName}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) =>
                                            updateRecordAddressField(
                                                'ownerName',
                                                e.target.value
                                            )
                                        }
                                    />
                                </Grid>
                                <Grid item sm={12} md={3}>
                                    <TextField
                                        id="ownerDob"
                                        label="Data Nascimento"
                                        value={formatDate(recordData?.ownerDob)}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) =>
                                            updateRecordAddressField(
                                                'ownerDob',
                                                e.target.value
                                            )
                                        }
                                    />
                                </Grid>
                                <Grid item sm={12} md={3}>
                                    <TextField
                                        id="ownerPhone"
                                        label="Telefone"
                                        value={recordData?.ownerPhone}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) =>
                                            updateRecordAddressField(
                                                'ownerPhone',
                                                e.target.value
                                            )
                                        }
                                    />
                                </Grid>
                                <Grid item sm={12} md={3}>
                                    <TextField
                                        id="ownerEmail"
                                        label="Email"
                                        value={recordData?.ownerEmail}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) =>
                                            updateRecordAddressField(
                                                'ownerEmail',
                                                e.target.value
                                            )
                                        }
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={3}>
                                <Grid item sm={12} md={4}>
                                    <TextField
                                        id="ownerAddress"
                                        label="Endereço"
                                        value={recordData?.ownerAddress}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) =>
                                            updateRecordAddressField(
                                                'ownerAddress',
                                                e.target.value
                                            )
                                        }
                                    />
                                </Grid>
                                <Grid item sm={12} md={4}>
                                    <TextField
                                        id="ownerNumber"
                                        label="Número"
                                        value={recordData?.ownerNumber}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) =>
                                            updateRecordAddressField(
                                                'ownerNumber',
                                                e.target.value
                                            )
                                        }
                                    />
                                </Grid>
                                <Grid item sm={12} md={4}>
                                    <TextField
                                        id="ownerComplement"
                                        label="Complemento"
                                        value={recordData?.ownerComplement}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) =>
                                            updateRecordAddressField(
                                                'ownerComplement',
                                                e.target.value
                                            )
                                        }
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={3}>
                                <Grid item sm={12} md={4}>
                                    <TextField
                                        id="ownerDistrict"
                                        label="Bairro"
                                        value={recordData?.ownerDistrict}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) =>
                                            updateRecordAddressField(
                                                'ownerDistrict',
                                                e.target.value
                                            )
                                        }
                                    />
                                </Grid>
                                <Grid item sm={12} md={4}>
                                    <TextField
                                        id="ownerCity"
                                        label="Cidade"
                                        value={recordData?.ownerCity}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) =>
                                            updateRecordAddressField(
                                                'ownerCity',
                                                e.target.value
                                            )
                                        }
                                    />
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <TextField
                                        id="ownerState"
                                        label="Estado"
                                        value={recordData?.ownerState}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) =>
                                            updateRecordAddressField(
                                                'ownerState',
                                                e.target.value
                                            )
                                        }
                                    />
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <TextField
                                        id="ownerCep"
                                        label="Cep"
                                        value={recordData?.ownerCep}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) => {
                                            const value = e.target.value
                                            updateRecordAddressField(
                                                'ownerCep',
                                                value
                                            )
                                            setPassengerCep(value)
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>

                        <h4>Contato Emergência</h4>
                        <Paper style={{ padding: '10px' }}>
                            <Grid container spacing={3}>
                                <Grid item sm={12} md={4}>
                                    <TextField
                                        id="emergencyName"
                                        label="Nome Emergência"
                                        value={recordData?.emergencyName}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) =>
                                            updateRecordAddressField(
                                                'emergencyName',
                                                e.target.value
                                            )
                                        }
                                    />
                                </Grid>
                                <Grid item sm={12} md={4}>
                                    <TextField
                                        id="emergencyCellphone"
                                        label="Celular Emergência"
                                        value={recordData?.emergencyCellphone}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) =>
                                            updateRecordAddressField(
                                                'emergencyCellphone',
                                                e.target.value
                                            )
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Paper>

                        <DialogActions
                            style={{ marginBottom: '20px', marginTop: '30px' }}
                        >
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => setUpdateOwnerDateModal(false)}
                            >
                                CANCELAR
                            </Button>
                            <Button
                                variant="contained"
                                style={{ backgroundColor: 'green' }}
                                onClick={handleUpdateOwnerData}
                                color="primary"
                                autoFocus
                            >
                                ATUALIZAR
                            </Button>
                        </DialogActions>
                    </DialogContent>
                </Dialog>
            </div>
        )
    } else
        return (
            <center style={{ marginTop: '20px' }}>
                <b
                    style={{
                        fontWeight: '600',
                        fontSize: '18px',
                        color: '#2c2c2c',
                        marginTop: '20px',
                    }}
                >
                    Carregando...
                </b>
                <br />
                <span style={{ fontSize: '14px', color: '#979797' }}>
                    Recuperando informações do pedido
                </span>
            </center>
        )
}
